import { Injectable, Type, ComponentFactoryResolver, InjectionToken, Inject } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient, HttpHeaders, HttpParams, HttpParameterCodec, HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { map, catchError, flatMap, take, timeout, retry, tap, finalize, shareReplay } from 'rxjs/operators';
import { empty, throwError, Observable, Observer, EMPTY, of, firstValueFrom } from 'rxjs';
import { AuthenticationService } from "./authentication.service";
import { AppService } from './app.service';
import { RolePermissionService } from './role-permission.service';
import { LoaderService } from '../../services/loader.service';
import { Title, DomSanitizer } from '@angular/platform-browser';
import { TranslatePipe } from '../../pipes/translate.pipe';
import _moment from 'proxies/dayjs';

import * as CryptoJS from 'crypto-js';
import { ModalService } from '../../services/modal.service';
import { StorageService } from './storage.service';
import { AlertsService } from '../../services/alerts.service';
import { ModalSize } from '../../services/smart-modal.service';
import { UtilService } from '../../services/util.service';
import get from 'lodash-es/get';
import set from 'lodash-es/set';
import unset from 'lodash-es/unset';
import { TranslateService } from '../../services/translate.service';
import { ErrorLoggingService } from '../../services/error-logging.service';
import { PDFDocument } from 'src/assets/js/pdf-lib.min.js';
// import { MacService } from './mac.service';
declare var google;
declare var window;
const moment = _moment;

@Injectable({
    providedIn: 'root'
})
export class BaseService {
    httpOptions: any;
    _resourceName: string;
    httpEncodingInstance: any = null;
    isExtended: boolean = false;
    _currentTitle: string = '';
    backNavigation: boolean = false;
    scriptLoaded: any;
    subsForDyanamicForm = {};
    subsForNocodeForm = {};
    patientChanged: boolean = false;
    cacheObj: any = {};
    private ongoingRequests = new Map<string, Observable<any>>();
    constructor(
        private _http: HttpClient,
        public router: Router,
        public authenticationService: AuthenticationService,
        private alertsService: AlertsService,
        private storageService: StorageService,
        private appService: AppService,
        public rolePermissionService: RolePermissionService,
        private loaderService: LoaderService,
        private translatePipe: TranslatePipe,
        private titleService: Title,
        private _componentFactoryResolver: ComponentFactoryResolver,
        public modalService: ModalService,
        private sanitizer: DomSanitizer,
        public utilService: UtilService,
        public route?: ActivatedRoute,
        private translateService?: TranslateService,
        // private macService?: MacService
    ) {
        this.setHttpOptions();
    }

    setHttpOptions() {
        return this.httpOptions = {
            //added for encoding issue of texteditor
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                'timezone': this.appService.getUserTimezone(),
                'current_time': this.appService.getCurrentTime(),
                'current_url': this.router.url,
                'host_name': window.location.host
            }),
            responseType: 'text',
            observe: 'response' as 'response'
        }
    }

    init(resourceName: string) {
        this._resourceName = resourceName;
        return this._resourceName;
    }
    showApiError(message: string) {
        if (this.appService._currentSessionData.deviceAuthenticated != undefined && !this.appService._currentSessionData.deviceAuthenticated) {
            return;
        }
        this.alertsService.error(message);
    }
    handleErrorFn(error: any) {
        if (error.status == '200') {
            return empty();
        }
        return throwError(error);
    }
    addAutoFilters(filter, resourceDef, queryId = false) {
        if (filter == undefined) {
            return "";
        }
        if (this.appService.getAppData().AUTO_FILTERS != undefined && this.appService.getAppData().AUTO_FILTERS.length > 0) {
            for (let index = 0; index < this.appService.getAppData().AUTO_FILTERS.length; index++) {
                var singleFilter = this.appService.getAppData().AUTO_FILTERS[index];

                //then check if its universal config based filter or check if its not needed
                //check if config key is provide in app config
                // check if it is enabled on  universal configration from backend

                if (singleFilter["filter_key"] != undefined && ((singleFilter["universal_config_enabled"] && singleFilter["universal_config_key"] != undefined && (this.appService.getUniversalConfig(singleFilter["universal_config_key"]))) || singleFilter["universal_config_enabled"] == false) && resourceDef["config"] != undefined && resourceDef["config"][singleFilter["filter_key"]] != undefined && resourceDef["config"][singleFilter["filter_key"]]["filter"] != undefined && resourceDef["config"][singleFilter["filter_key"]]["filter"]) {

                    if (singleFilter["universal_config_enabled"]) {
                        if (singleFilter["getterFun"] != undefined) {
                            if ((resourceDef["config"][singleFilter["filter_key"]]["filter_query_id"] == undefined) || (resourceDef["config"][singleFilter["filter_key"]]["filter_query_id"] != undefined && (!this.checkFilterQueryId(resourceDef["config"][singleFilter["filter_key"]]["filter_query_id"], queryId)))) {
                                filter = (filter != "" && filter) ? (filter + ',' + singleFilter["filter_key"] + ':' + singleFilter["getterFun"](this.appService._currentSessionData)) : (singleFilter["filter_key"] + ':' + singleFilter["getterFun"](this.appService._currentSessionData));
                            }

                        }
                    } else {
                        //todo
                    }
                }
            }
        }
        return filter;
    }

    checkFilterQueryId(filter_query_id: any, queryId: any) {
        return filter_query_id.includes(",") ? filter_query_id.split(",").filter(x => x == queryId).length != 0 : (queryId == filter_query_id)
    }
    // get Method
    get(queryId, args, resource = null, application?: any, filter?: any, responseType?: any, config?: any, excludeFields?: string[]) {
        var currentResource = (resource) ? resource : this._resourceName;
        // console.log("Args In get are ", args);
        if (this.getSessionId() != null) {
            return new Observable((observer: Observer<any>) => {
                this.getResourceDef(currentResource, (resourceDef) => {
                    if (resourceDef) {
                        filter = this.addAutoFilters(filter, resourceDef, queryId);
                        filter = this.checkArgsandEncode(filter);
                        if (resourceDef.config != undefined && this.appService.isFacilityAware() && this.checkForQueryAccountAware(resourceDef.config, queryId)) {
                            this.storageService.getSessionStorageDataSimple(this.appService.getAppData().ORG_KEY, facility_id => {
                                if (facility_id) {
                                    args = (args != "") ? args + ',' + this.appService.getAppData().ORG_KEY + ':' + facility_id : this.appService.getAppData().ORG_KEY + ':' + facility_id;
                                }
                                this.getDataFn(observer, queryId, args, currentResource, application, filter, responseType, config, excludeFields);
                            });
                        } else {
                            this.getDataFn(observer, queryId, args, currentResource, application, filter, responseType, config, excludeFields);
                        }
                    } else {
                        this.getDataFn(observer, queryId, args, currentResource, application, filter, responseType, config, excludeFields);
                    }
                });
            });
        }
    }

    checkForQueryAccountAware(config, queryId) {
        if (config.account_aware != undefined && config.account_aware.get != undefined) {
            if (Array.isArray(config.account_aware.get)) {
                //return true if query id exists in array
                return (config.account_aware.get.indexOf(queryId) > -1);
            } if (typeof config.account_aware.get == "string") {
                //true if equal to query id or all to allow all querys
                return (config.account_aware.get == queryId || config.account_aware.get == "all");
            }
        }
        return false;
    }

    getDataFn(observer, queryId, args, currentResource = null, application?: any, filter?: any, responseType?: any, config?: any, excludeFields?: string[]) {
        var url = this.get_url(queryId, args, currentResource, application, filter, responseType, config, excludeFields);
        var cacheKey: any = false
        if (config && config["cache"] != undefined && config['cache']) {
            cacheKey = CryptoJS.MD5(url).toString();
            const data = this.getCachedData(cacheKey)
            if (data) {
                observer.next(data);
                observer.complete();
                return;
            }
        }

        this.httpGet(url, currentResource, responseType)
            .pipe(take(1))
            .subscribe(
                (data: any) => {
                    if (cacheKey) {
                        this.setCachedData(cacheKey, data)
                    }
                    observer.next(data);
                    observer.complete();
                });
    }

    httpGet(url, currentResource = false, options) {
        var urlData = url.split("?");

        if (options == undefined) {
            options = {};
        }
        return new Observable((observer: Observer<any>) => {
            this.getResourceDef(currentResource, (res: any) => {
                var inputHeaders;
                if (options != undefined && options.headers != undefined) {
                    inputHeaders = options.headers
                    delete options.headers;
                } else {
                    inputHeaders = false;
                }

                if (res && res.login_required != undefined) {
                    if (urlData[1] != undefined) {
                        options = { ...this.addGetXsrfToken(urlData[1], res.login_required), ...options };
                    } else {
                        options = { ...this.addGetXsrfToken("", res.login_required), ...options };
                    }
                } else {
                    if (urlData[1] != undefined) {
                        options = { ...this.addGetXsrfToken(urlData[1], true), ...options };
                    } else {
                        options = { ...this.addGetXsrfToken("", true), ...options };
                    }
                }
                if (inputHeaders) {
                    inputHeaders.keys().forEach(key => {
                        const value = inputHeaders.get(key);
                        if (value !== null) {
                            options.headers = options.headers.set(key, value);
                        }
                    });
                }
                this.httpGetFile(url, currentResource, options, observer).pipe(take(1)).subscribe((data: any) => {
                    observer.next(data);
                    observer.complete();
                })
            })
        })

    }

    httpGetFile(url, currentResource = false, options, observer) {
        return this._http.get(url, options)
            .pipe(
                retry(1),
                flatMap((result: any) => {
                    if (currentResource) {
                        return this.decryptResponse(currentResource, result, { single: false, url: url });
                    } else {
                        return new Promise<any>((resolve, reject) => {
                            resolve(result);
                        })
                    }
                }),
                (catchError(error => {
                    // Added to show error if network errors occurs
                    if (!navigator.onLine) {
                        this.showApiError("Check your network connection");
                        this.loaderService.hideSpinner();
                        return EMPTY;
                    } else if (error.status == 504) {
                        this.showApiError("nto");
                        this.loaderService.hideSpinner();
                        return EMPTY;
                    } else {
                        if (error.status == 400) {
                            console.error("Please check your cluster configuration it might be missing!");
                        }
                        this.loaderService.hideSpinner();
                    }
                    return throwError(error);
                }))
            )
    }

    get_url(queryId, args, resource = null, application?: any, filter?: any, responseType?: any, config?: any, excludeFields?: string[]) {
        var currentResource = (resource) ? resource : this._resourceName;
        let filterparam = ""
        if (this._resourceName == undefined) {
            this._resourceName = "application";
        }
        // console.log("Application ", application);
        if (application == '' || application == undefined) {
            application = this.getAppName();
        }
        // console.log("Resource is ", resource);
        if (filter != undefined) {
            filterparam = filter != undefined ? '&filter=' + this.checkArgsandEncode(filter) : "";
        }

        if (config == undefined || (config != undefined && config.facility == undefined) || (config != undefined && config.facility != undefined && config.facility)) {
            if (this.appService.getAppData().ORG_AWARE != undefined && this.appService.getAppData().ORG_AWARE && this.appService.getOrganization()) {
                var x = this.appService.getOrganization();
                args = this.appService.getAppData().ORG_KEY + ":" + x.org_id + ((args == '') ? '' : ',') + args;
            }
        }

        if (this.appService.getCurrentLocation()) {
            args += ((args == '') ? '' : ',') + 'location_id:' + this.appService.getCurrentLocation().location_id;
        }
        args = this.checkArgsandEncode(args);
        let responseType_ = responseType != undefined ? responseType : "";

        let field = "";
        if (config?.field != undefined && config?.field != "") {
            field = "&field=" + config.field;
        }

        return this.getApiEndpoint(application) + currentResource + '?queryId=' + queryId + '&args=' + args + "&application=" + application + filterparam + field + (excludeFields?.length > 0 ? `&excludeFields=${excludeFields.join(',')}` : '');
    }

    checkargs(args) {
        if (args != "" && typeof args == 'string') {
            let arg = args.split(',');
            let argForQuery = [];
            for (let i = 0; i < arg.length; i++) {
                let val = arg[i].split(':');
                if (val[1] != undefined && val[1] != '') {
                    argForQuery.push(val[0] + ":" + val[1]);
                }
            }
            return argForQuery.join(",")
        } else {
            return args.toString();
        }
    }

    checkArgsandEncode(args) {
        if (args != "" && typeof args == 'string') {
            let arg = args.split(',');
            let argForQuery = [];
            for (let i = 0; i < arg.length; i++) {
                let val = arg[i].split(':');
                if (val[1] != undefined && val[1] != '') {
                    argForQuery.push(val[0] + ":" + encodeURIComponent(val[1]));
                }
            }
            return argForQuery.join(",")
        } else {
            return args?.toString();
        }
    }
    //this function removes keys from string as given in array
    removeKeys(val: string, removeKey: []) {
        let strArray = val.split(',');
        let cloneArray = JSON.parse(JSON.stringify(strArray));
        for (let data of strArray) {
            if (removeKey.find(x => x === data.split(":")[0])) {
                const index = strArray.indexOf(data);
                if (index > -1) {
                    strArray.splice(index, 1);
                }
            }
        }
        return strArray.join();
    }

    getWithoutfacilityId(queryId, args, resource = null, application?: any, filter?: any, responseType?: any) {
        return this.get(queryId, args, resource, application, filter, responseType, { facility: false });
    }

    //get as per resource  TO BE DISCUSSED
    getDataAsPerResource(queryId, args, resource, application?: any, filter?: any) {
        return this.get(queryId, args, resource, application, filter);
    }
    // Add Method
    add(_resource, resourceName?, isLoginNeeded = true, application?, action?: any) {
        var encodedResourceData;
        if (this.appService._currentSessionData.debuggingMode != undefined && this.appService._currentSessionData.debuggingMode) {
            encodedResourceData = unescape(encodeURIComponent(JSON.stringify(_resource)));
            var params = "resource=" + encodedResourceData;
        } else {
            encodedResourceData = btoa(unescape(encodeURIComponent(JSON.stringify(_resource))));
            var params = "resource=" + encodedResourceData;
        }

        if (resourceName == undefined) {
            resourceName = this._resourceName;
        }
        var headers
        // if(resourceName !='login'){
        return new Observable((observer: Observer<any>) => {
            this.getResourceDef(resourceName, (res) => {
                if (res && res.login_required != undefined) {
                    if (action != undefined && action != "") {
                        encodedResourceData += "&action=" + action
                    }
                    headers = this.addXsrfToken(encodedResourceData, res.login_required);
                    this.addAfterResource(observer, _resource, params, headers, resourceName, isLoginNeeded, application, action)
                } else {
                    if (action != undefined && action != "") {
                        encodedResourceData += "&action=" + action
                    }
                    headers = this.addXsrfToken(encodedResourceData, true);
                    this.addAfterResource(observer, _resource, params, headers, resourceName, isLoginNeeded, application, action)
                }
            })
        })

    }


    addAfterResource(observer, _resource, params, headers, resourceName?, isLoginNeeded = true, application?, action?: any) {
        if (application == undefined || application == '') {
            params += "&application=" + this.getAppName();
        } else {
            params += "&application=" + application;
        }

        var args = '';
        if (this.appService.getCurrentLocation()) {
            args = '?args=location_id:' + this.appService.getCurrentLocation().location_id;
        }
        if (action != undefined) {
            params += "&action=" + action
        }

        this.postAddData(_resource, params, headers, args, resourceName, isLoginNeeded, application, action).pipe(take(1)).subscribe((data) => {
            observer.next(data);
            observer.complete();
        })
    }

    postAddData(_resource, params, headers, args, resourceName, isLoginNeeded, application, action) {
        let url = this.getApiEndpoint(application) + resourceName + args;
        return this._http.post(url, params, headers)
            .pipe(
                flatMap((result: any) => {
                    return this.decryptResponse(resourceName, result, { url: url, single: false, isLoginNeeded: isLoginNeeded });
                }),
                (catchError(error => {
                    if (!navigator.onLine) {
                        this.showApiError("Check your network connection");
                        this.loaderService.hideSpinner();
                        return EMPTY;
                    } else if (error.status == 504) {
                        if (url == "/account-management/api/v1/login") {
                            this.showApiError("er1");
                        } else {
                            this.showApiError("nto");
                        }
                        this.loaderService.hideSpinner();
                        return EMPTY;
                    } else if (error.status == 200) {
                        return empty()
                    } else {
                        this.loaderService.hideSpinner();
                    }
                    return throwError(error);
                }))

            )
    }

    getHttpEncodingInstance() {
        if (this.httpEncodingInstance == null) {
            this.httpEncodingInstance = new HttpFormEncodingCodec();
        }
        return this.httpEncodingInstance;
    }

    addGetXsrfToken(data, login_required) {
        return this.appService.addGetXsrfToken(data, login_required);
    }

    addXsrfToken(data, login_required) {
        return this.appService.addXsrfToken(data, login_required);
    }

    // Based on Condition 
    action(_resource, action, application?, resource?, bpmn_action?, responseType?, args?, obj?) {

        //adding location to the resource
        this.addLocation(_resource);

        console.log("resource name Is :; ", this._resourceName);
        var currentResource = (resource == '' || resource == undefined) ? this._resourceName : resource;
        application = (application == '' || application == undefined) ? this.getAppName() : application;

        return new Observable((observer: Observer<any>) => {
            this.getResourceDef(currentResource, (resourceDef) => {
                if (resourceDef) {
                    this.addFacilityIdIfRequired(observer, resourceDef, currentResource, _resource, action, application, resource, bpmn_action, responseType, args, obj);
                } else {
                    this.addFacilityIdIfRequired(observer, resourceDef, currentResource, _resource, action, application, resource, bpmn_action, responseType, args, obj);
                }
            });
        });
    }


    addLocation(resource) {

        try {
            if (resource != undefined && resource.tag_data != undefined && this.appService.getCurrentLocation().location_id && !resource.tag_data.find(x => x.key_name == 'internal_location')) {
                resource.tag_data.push({ "key_name": "internal_location", "key_value_code": this.appService.getCurrentLocation().location_id, "key_value_display": this.appService.getCurrentLocation().location_id })
            }
            else if (resource != undefined && resource.tag_data == undefined) {
                resource.tag_data = [];
                resource.tag_data.push({ "key_name": "internal_location", "key_value_code": this.appService.getCurrentLocation().location_id, "key_value_display": this.appService.getCurrentLocation().location_id })
            }
        } catch (error) {
            console.warn("error while adding location")
        }
    }

    setAccountAwareFacilityID(facility_id, callback = null) {
        this.storageService.setSessionStorageData(this.appService.getAppData().ORG_KEY, facility_id, () => {
            if (callback != null) {
                callback();
            }
        });
    }

    getEncodedData(_resource, action, application?, bpmn_action?, obj?) {
        var encodedResourceData;
        if (this.appService._currentSessionData.debuggingMode != undefined && this.appService._currentSessionData.debuggingMode) {
            encodedResourceData = unescape(encodeURIComponent(JSON.stringify(_resource)));
            var encodedResource = this.doPost(encodedResourceData);
        } else {
            encodedResourceData = btoa(unescape(encodeURIComponent(JSON.stringify(_resource))));
            var encodedResource = this.doPost(encodedResourceData);
        }
        let bpmn = bpmn_action != undefined ? "&sync=" + bpmn_action : "";
        // application = application === "report-management" ? this.appService.getApplication() : application;
        var appPrint = '';
        if (['print', 'download', 'view_file'].indexOf(action) > -1) {
            appPrint = "&appPrint=Y";
        }
        var params = encodedResource + "&action=" + action + bpmn + appPrint + "&application=" + application;
        if (obj != undefined && obj.postProjectionKeys != undefined) {
            params = params + '&projectionKeys=' + obj.postProjectionKeys;
        }
        return { encodedResourceData: encodedResourceData, params: params };
    }

    addFacilityIdIfRequired(observer, resourceDef, currentResource, _resource, action, application?, resource?, bpmn_action?, responseType?, args?, obj?) {
        if (this.appService.getCurrentLocation()) {
            if (args == undefined)
                args = '?args=location_id:' + this.appService.getCurrentLocation().location_id;
            else
                args = '?args=location_id:' + this.appService.getCurrentLocation().location_id + ',' + args;
        } else if (args != undefined) {
            args = '?args=' + args;
        } else
            args = '';

        var inputHeaders;
        if (responseType != undefined && responseType.headers != undefined) {
            inputHeaders = responseType.headers
            delete responseType.headers;
        } else {
            inputHeaders = false;
        }
        // if account aware and the resource is faility aware and either post is defined as true or its undefined we will need facility id.
        if ((resourceDef.config != undefined && resourceDef.config.account_aware != undefined && this.appService.isFacilityAware()) && ((resourceDef.config.account_aware.post != undefined && resourceDef.config.account_aware.post) || (resourceDef.config.account_aware.post == undefined))) {
            let application_ = application ? application : "";
            this.storageService.getSessionStorageDataSimple(this.appService.getAppData().ORG_KEY, facility_id => {
                if (!facility_id) {
                    var data: any = { errCode: -1, message: "facility id not found." };
                    observer.next(data);
                    observer.complete();
                    return;
                }
                _resource[this.appService.getAppData().ORG_KEY] = facility_id;
                var postData = this.getEncodedData(_resource, action, application, bpmn_action, obj);
                if (action != undefined && action != "") {
                    postData.encodedResourceData += "&action=" + action
                }
                var options: any = this.addXsrfToken(postData.encodedResourceData, (resourceDef.login_required != undefined ? resourceDef.login_required : true));
                var configOption: any = {};
                if (responseType != undefined && responseType.catchError != undefined) {
                    configOption.catchError = responseType.catchError;
                    delete responseType.catchError;
                }
                if (responseType != undefined) {
                    options = { ...options, ...responseType };
                }
                if (inputHeaders) {
                    inputHeaders.keys().forEach(key => {
                        const value = inputHeaders.get(key);
                        if (value !== null) {
                            options.headers = options.headers.set(key, value);
                        }
                    });
                }
                if (responseType != undefined && responseType.responseType != undefined && (responseType.responseType == "blob" && currentResource.includes('/print') || (responseType.responseType == "application/json" && currentResource.includes('/download')))) {
                    // if (_resource.template == "grid" && _resource.newPrint)
                    application_ = "printengine";
                    // else
                    //     application_ = "report-management";
                }
                var url = this.getApiEndpoint(application_) + currentResource + args;


                this.postAction(currentResource, url, postData.params, options, configOption).pipe(take(1)).subscribe(
                    (data: any) => {
                        observer.next(data);
                        observer.complete();
                    },
                    error => {
                        console.log("Action servived error in base if", error);
                        observer.error(error);
                    })
            });
        } else {
            let application_ = application ? application : "";
            var postData = this.getEncodedData(_resource, action, application, bpmn_action, obj);
            if (action != undefined && action != "") {
                postData.encodedResourceData += "&action=" + action
            }
            var options: any = this.addXsrfToken(postData.encodedResourceData, (resourceDef.login_required != undefined ? resourceDef.login_required : true));
            var configOption: any = {};
            if (responseType != undefined && responseType.catchError != undefined) {
                configOption.catchError = responseType.catchError;
                delete responseType.catchError;
            }
            if (responseType != undefined) {
                options = { ...options, ...responseType };
            }
            if (inputHeaders) {
                inputHeaders.keys().forEach(key => {
                    const value = inputHeaders.get(key);
                    if (value !== null) {
                        options.headers = options.headers.set(key, value);
                    }
                });
            }
            if (responseType != undefined && responseType.responseType != undefined && ((responseType.responseType == "blob" || responseType.responseType == "application/text") && currentResource.includes('/print') || (responseType.responseType == "application/json" && currentResource.includes('/download')))) {
                // if (this.appService && this.appService._currentSessionData) {
                if (_resource.template == "grid") {
                    application_ = "bulk-download";
                }
                else {
                    application_ = "printengine";
                    // if (_resource.contentType != undefined && _resource.contentType == "xlsx") {
                    //     application_ = "bulk-download";
                    // }
                    // else {
                    //     application_ = "printengine";
                    // }
                }
                // if (_resource.template == "grid")
                //     application_ = "bulk-download";
                // else {
                //     if (responseType != undefined && responseType.printApplication != undefined && responseType.printApplication) {
                //         application_ = "bulk-download";
                //     }
                // else {
                //     application_ = "report-management";
                // }
                // }
                // }
                // else {
                // if (_resource && _resource.newPrint != null && _resource.newPrint) { // It's a temporary function, we should remove after new print templates avaiable live.
                //     if (this.appService.printEngineTemplate && this.appService.printEngineTemplate.length > 0) {
                //         let finalValue = this.appService.printEngineTemplate.some(x => x.id == _resource.template);
                //         if (finalValue) {
                //             if (_resource.template == "grid")
                //                 application_ = "bulk-download";
                //             else
                //                 application_ = "printengine";
                //         } else {
                //             application_ = "report-management";
                //         }
                //     }
                //     else {
                //         application_ = "report-management";
                //     }
                // }
                // else {
                //     if (responseType != undefined && responseType.printApplication != undefined && responseType.printApplication && responseType.responseType != undefined && responseType.responseType == "blob" && currentResource.includes('/print')) {
                //         application_ = "printengine";
                //     } 
                //     else if (responseType != undefined && responseType.printApplication != undefined && responseType.printApplication) {
                //         application_ = "bulk-download";
                //     }
                //     else {
                //         application_ = "report-management";
                //     }
                // }
                // }
            }
            else if (responseType != undefined && responseType.printApplication != undefined && responseType.printApplication && responseType.responseType != undefined && responseType.responseType == "blob" && currentResource.includes('/print')) {
                application_ = "printengine";
            }
            else if (responseType != undefined && responseType.printApplication != undefined && responseType.printApplication) {
                application_ = "bulk-download";
            }
            var url = this.getApiEndpoint(application_) + currentResource + args;
            this.postAction(currentResource, url, postData.params, options, configOption).pipe(take(1)).subscribe(
                (data: any) => {
                    observer.next(data);
                    observer.complete();
                },
                error => {
                    console.log("Action servived error in base", error);
                    observer.error(error);
                })
        }

    }

    postAction(currentResource, url, params, options, config?) {
        //this is the case where user is only allowed to view the things update and add is not allowed
        if (this.appService._currentSessionData != undefined && this.appService._currentSessionData.view_only != undefined && this.appService._currentSessionData.view_only === true && currentResource != "logout" && currentResource != 'change_care_type' && !url.includes('bulk-download') && currentResource != 'audit_log') {
            this.alertsService.error("User is for view mode only");
            this.loaderService.hideSpinner();
            return EMPTY;
        } else {
            try {
                if (this.appService != undefined && this.appService._currentSessionData != undefined && this.appService._currentSessionData.view_only != undefined && this.appService._currentSessionData.view_only === true && url.includes('bulk-download')) {
                    if (this.appService != undefined && this.appService._currentSessionData != undefined && !this.appService._currentSessionData.view_only_download) {
                        this.alertsService.error("User is for view mode only");
                        this.loaderService.hideSpinner();
                        return EMPTY;
                    }
                    else if (this.appService != undefined && this.appService._currentSessionData != undefined && this.appService._currentSessionData.view_only_download) {
                        return this.postHit(currentResource, url, params, options, config);
                    }
                }
                else {
                    return this.postHit(currentResource, url, params, options, config);
                }
            } catch (error) { }

        }
    }

    postHit(currentResource, url, params, options, config?) {
        return this._http.post(url, params, options)
            .pipe(
                flatMap((result: any) => {
                    return this.decryptResponse(currentResource, result, { single: false, url: url, options: options });
                }),
                (catchError(error => {
                    console.log("Post Action failed in base service ", error);
                    if (error.status == 200) {
                        return empty()
                    } else if (!navigator.onLine) {
                        this.showApiError("Check your network connection");
                        this.loaderService.hideSpinner();
                        return EMPTY;
                    } else if (error.status == 504 && config != undefined && config.catchError != undefined && config.catchError) {
                        return new Promise<any>((resolve, reject) => { resolve({ errCode: 504 }) })
                    } else if (error.status == 504) {
                        this.showApiError("nto");
                        this.loaderService.hideSpinner();
                        return EMPTY;
                    } else {
                        this.loaderService.hideSpinner();
                    }
                    return throwError(error);
                }))

            )
    }

    // added by ankita to call the external api in json format
    externalPostAction(currentResource, url, params, options): Observable<any> {
        return this._http.post(url, params, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            }),
            responseType: 'json'
        })
            .pipe(
                map((result: any) => {
                    return result;
                }),
                (catchError(error => {
                    if (error.status == 200) {
                        return empty()
                    } else if (!navigator.onLine) {
                        this.showApiError("Check your network connection");
                        this.loaderService.hideSpinner();
                        return EMPTY;
                    } else if (error.status == 504) {
                        this.showApiError("nto");
                        this.loaderService.hideSpinner();
                        return EMPTY;
                    } else {
                        this.loaderService.hideSpinner();
                    }
                    return throwError(error);
                }))
            )
    }
    // Upload 
    upload(body, application?, resource?, fileContent?, bulk?, responseType?) {
        var currentResource = (resource == '' || resource == undefined) ? this._resourceName : resource;
        let url = this.getApiEndpoint(application) + currentResource + (bulk == true ? '/bulkupload' : '');
        // if (fileContent) {
        //     var encrypted = this.appService.getXsrfToken(fileContent);
        // } else {
        //     var encrypted = this.appService.getXsrfToken("");
        // }

        if (!responseType) {
            responseType = "text";
        }


        return new Observable((observer: Observer<any>) => {
            var encrypted
            this.getResourceDef(resource, (res: any) => {
                var fileContentCSRF = fileContent;
                if (body.get("fileName")) {
                    fileContentCSRF = body.get("fileName") + "__" + fileContent
                }

                if (res && res.login_required != undefined) {
                    if (fileContentCSRF) {
                        encrypted = this.appService.getXsrfToken(fileContentCSRF, res.login_required);
                    } else {
                        encrypted = this.appService.getXsrfToken("", res.login_required);
                    }
                } else {
                    if (fileContentCSRF) {
                        encrypted = this.appService.getXsrfToken(fileContentCSRF, true);
                    } else {
                        encrypted = this.appService.getXsrfToken("", true);
                    }
                }
                this.postUploadData(observer, body, application, resource, fileContent, bulk, responseType, encrypted, currentResource, url).pipe(take(1)).subscribe((data) => {
                    observer.next(data);
                    observer.complete();
                })
            })
        })


    }

    postUploadData(observer, body, application, resource, fileContent, bulk, responseType, encrypted, currentResource, url) {
        return this._http.post(url, body, {
            headers: new HttpHeaders().set('X-XSRF-TOKEN', encrypted).set('timezone', this.appService.getUserTimezone()).set('current_time', this.appService.getCurrentTime()).set('current_url', this.router.url)
                .set('host_name', window.location.host),
            responseType: responseType,
            observe: 'response' as 'response'
        }).pipe(
            flatMap((result: any) => {
                return this.decryptResponse(currentResource, result, { single: false });
            }),
            (catchError(error => {
                if (!navigator.onLine) {
                    this.showApiError("Check your network connection");
                    this.loaderService.hideSpinner();
                    return EMPTY;
                } else if (error.status == 504) {
                    this.showApiError("nto");
                    this.loaderService.hideSpinner();
                    return EMPTY;
                } else if (error.status == 200) {
                    return empty()
                } else if (error.status == 403) {
                    this.showApiError("403error");
                    this.loaderService.hideSpinner();
                    return EMPTY;
                } else {
                    this.loaderService.hideSpinner();
                }
                return throwError(error);
            }))
        )
    }

    // get By Id
    getById(id, resource?: string, application?, excludeFields?: Array<string>) {
        resource ? this._resourceName = resource : this._resourceName;
        if (application == '' || application == undefined) {
            application = this.getAppName();
        }
        var url = this.getApiEndpoint(application) + this._resourceName + "?queryId=GET_BY_ID&args=id:" + id + "&application=" + application;
        if (excludeFields != undefined && excludeFields.length > 0) {
            url += "&excludeFields=" + excludeFields.join();
        }
        var urlData = url.split("?");

        var options: any = {};

        return new Observable((observer: Observer<any>) => {
            this.getResourceDef(this._resourceName, (res: any) => {
                if (res && res.login_required != undefined) {
                    if (urlData[1] != undefined) {
                        options = { ...this.addGetXsrfToken(urlData[1], res.login_required), ...options };
                    } else {
                        options = { ...this.addGetXsrfToken("", res.login_required), ...options };
                    }
                } else {
                    if (urlData[1] != undefined) {
                        options = { ...this.addGetXsrfToken(urlData[1], true), ...options };
                    } else {
                        options = { ...this.addGetXsrfToken("", true), ...options };
                    }
                }
                this.getDataResponse(observer, url, options).pipe(take(1)).subscribe((data) => {
                    observer.next(data);
                    observer.complete();
                })
            })
        })
    }

    getDataResponse(observer, url, options) {
        return this._http.get(url, options)
            .pipe(
                retry(1),
                flatMap((result: any) => {
                    return this.decryptResponse(this._resourceName, result, { single: true });
                }),
                (catchError(error => {
                    if (!navigator.onLine) {
                        this.showApiError("Check your network connection");
                        this.loaderService.hideSpinner();
                        return EMPTY;
                    } else if (error.status == 504) {
                        this.showApiError("nto");
                        this.loaderService.hideSpinner();
                        return EMPTY;
                    } else if (error.status == 200) {
                        return empty()
                    } else {
                        this.loaderService.hideSpinner();
                    }


                    return throwError(error);
                }))

            )
    }

    getByDataSource(apiObj) {
        return this.get(apiObj.query_id, apiObj.args, apiObj.resource, apiObj.application, apiObj.filter, apiObj.headers);
    }
    getUrlByDataSource(apiObj) {
        return this.get_url(apiObj.queryId, apiObj.args, apiObj.resource, apiObj.application, apiObj.filter);
    }

    getWithPage(data, resource?, application?, query_id?, obj?) {
        if (application == '' || application == undefined) {
            application = this.getAppName();
        }
        var params: any = false;
        var query: any = false;
        if (data.query_id != undefined && data.query_id) {
            query = data.query_id;
            delete data.query;
        }
        if (data.parameters != undefined && data.parameters) {
            params = [];
            for (let i = 0; i < Object.keys(data.parameters).length; i++) {
                params.push(Object.keys(data.parameters)[i] + ":" + data.parameters[Object.keys(data.parameters)[i]])
            }
            params = params.join('&');
            delete data.parameters;
        }
        // console.log("Resource NAme ", this._resourceName);
        if (data && !data.projectionKeys) {
            // check environment (dev or qa)
            const isWarningEnv = ['dev', 'qa'].includes(this.appService.getEnv());
            const apiName = (data.query_id || query_id);
            // allowed query_id with no projectionKeys
            const exemptApis = [
                'get_valueset_by_id_flat'
            ];
            if (isWarningEnv) {
                if (exemptApis.includes(apiName)) {
                    // skip warning
                } else {
                    console.warn("No projection key exists for API : " + (data.query_id ? data.query_id : query_id));
                }

            }
        }

        var currentResource = (resource) ? resource : this._resourceName;
        if (this.getSessionId() != null) {
            var args = "dummy:dummy";
            if (this.appService.getAppData().ORG_AWARE != undefined && this.appService.getAppData().ORG_AWARE && this.appService.getOrganization()) {
                var x = this.appService.getOrganization();
                args = this.appService.getAppData().ORG_KEY + ":" + x.org_id;
                if (data.args != undefined && data.args) {
                    args = this.appService.getAppData().ORG_KEY + ":" + x.org_id + ((args == '') ? '' : ',') + data.args;
                    delete data.args;
                }
            } else {
                if (data.args != undefined && data.args) {
                    args = data.args;
                    delete data.args;
                }
            }
            if (this.appService.getCurrentLocation()) {
                args += ((args == '') ? '' : ',') + 'location_id:' + this.appService.getCurrentLocation().location_id;
            }
            let queryID = query_id == undefined ? "GET_PAGE" : query_id;
            if (params) {
                args = params;
            }
            if (query) {
                queryID = query;
            }
            var responseType = 'text';

            /************ PRINT IMPLEMENTATION ********/
            if (data.printInfo != undefined) {
                currentResource = currentResource + "/print";
                responseType = data.printInfo.responseType;
                args = args + "&gridInfo=" + btoa(JSON.stringify(data.printInfo.gridInfo));
                if (data.printInfo.gridHeading != undefined) {
                    args = args + "&gridHeading=" + data.printInfo.gridHeading;
                }
                if (data.printInfo.filterInfo != undefined) {
                    args = args + "&filterInfo=" + btoa(JSON.stringify(data.printInfo.filterInfo));
                }
                if (data.printInfo.amount != undefined) {
                    args = args + "&amount=" + btoa(JSON.stringify(data.printInfo.amount));
                }
                delete data.printInfo;
            }


            var options: any = { responseType: responseType };
            /************ PRINT IMPLEMENTATION ********/

            // if(data.filter && data.filter != ''){
            //     data.filter = this.checkArgsandEncode(data.filter);
            // }         // commented due to adding extra unmwanted characters.
            let queryUri = Object.keys(data).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(data[k])}`).join('&');

            return new Observable((observer: Observer<any>) => {
                this.getResourceDef(currentResource, (resourceDef) => {
                    if (resourceDef) {
                        //sauravdeep changes here
                        // if (currentResource == "appointment")
                        //     debugger
                        data.filter = this.addAutoFilters(data.filter, resourceDef, queryID);
                        let queryUri = Object.keys(data).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(data[k])}`).join('&');


                        if (resourceDef.config != undefined && this.appService.isFacilityAware() && this.checkForQueryAccountAware(resourceDef.config, queryID)) {
                            this.storageService.getSessionStorageDataSimple(this.appService.getAppData().ORG_KEY, facility_id => {
                                if (facility_id) {
                                    args = args + "," + this.appService.getAppData().ORG_KEY + ':' + facility_id;
                                }
                                this.getWithPageFn(observer, application, currentResource, queryID, args, queryUri, options, obj);
                            });
                        } else {
                            this.getWithPageFn(observer, application, currentResource, queryID, args, queryUri, options, obj);
                        }
                    } else {
                        this.getWithPageFn(observer, application, currentResource, queryID, args, queryUri, options, obj);
                    }
                });
            });


        }
    }

    getWithPageFn(observer, application, currentResource, queryID, args, queryUri, options, obj?) {
        args = this.checkArgsandEncode(args);
        let application_ = application;
        if (currentResource.includes('/print') && options && options.responseType != undefined && options.responseType == "blob") {
            // application_ = "report-management";
            application_ = "printengine";
        }
        let queryargs = '?queryId=' + queryID + '&args=' + args + '&' + queryUri + "&application=" + application;
        // var url1 = this.getApiEndpoint(application_) + currentResource + queryargs;
        //var url = this.getApiEndpoint(application_) + currentResource + encodeURIComponent(queryargs);
        var url = this.getApiEndpoint(application_) + currentResource + queryargs;
        //for print 
        if (url.includes('/print') && options.responseType) { }
        var urlData = url.split("?");
        this.getResourceDef(currentResource, (res: any) => {
            if (res && res.login_required != undefined) {
                if (urlData[1] != undefined) {
                    options = { ...this.addGetXsrfToken(urlData[1], res.login_required), ...options };
                } else {
                    options = { ...this.addGetXsrfToken("", res.login_required), ...options };
                }
            } else {
                if (urlData[1] != undefined) {
                    options = { ...this.addGetXsrfToken(urlData[1], true), ...options };
                } else {
                    options = { ...this.addGetXsrfToken("", true), ...options };
                }
            }
            this.synchGet(url, options, currentResource, obj, observer);
        })
    }

    synchGet(url, options, currentResource, obj, observer) {
        this._http.get(url, options)
            .pipe(
                retry(1),
                flatMap((result: any) => {
                    return this.decryptResponse(currentResource, result, { single: false });
                }),
                (catchError(error => {
                    // Added to show error if network errors occurs
                    if (!navigator.onLine) {
                        this.showApiError("Check your network connection");
                        this.loaderService.hideSpinner();
                        return EMPTY;
                    } else if (error.status == 200) {
                        return empty()
                    }
                    else if (error.status == 504 && obj != undefined && obj.catchError != undefined && obj.catchError) {
                        return new Promise<any>((resolve, reject) => { resolve({ errCode: 504 }) })
                    }
                    else if (error.status == 504) {
                        this.showApiError("nto");
                        this.loaderService.hideSpinner();
                        return EMPTY;
                    } else {
                        this.loaderService.hideSpinner();

                    }
                    return throwError(error);
                }))

            ).pipe(take(1)).subscribe(
                (data: any) => {
                    data.url = url;
                    observer.next(data);
                    observer.complete();
                });
    }


    getData(data?, filterParams?, resource?, application?, query_id?, obj?) {
        if (!data && filterParams) {
            //TODO: call filter api here
        } else if (!data && !filterParams) {
            var args = "dummy:dummy";
            if (this.appService.getAppData().ORG_AWARE != undefined && this.appService.getAppData().ORG_AWARE && this.appService.getOrganization()) {
                var x = this.appService.getOrganization();
                args = this.appService.getAppData().ORG_KEY + ":" + x.org_id;
            }
            if (this.appService.getCurrentLocation()) {
                args += ((args == '') ? '' : ',') + 'location_id:' + this.appService.getCurrentLocation().location_id;
            }
            return this.get(query_id ? query_id : "GET_ALL", args, resource, application);
        } else {
            if (!filterParams) {
                return this.getWithPage(data, resource, application, query_id, obj);
            } else if (filterParams) {
                //TODO: call pagination api with filter here
            }
        }
    }


    getSessionId() {
        return this.appService.getSessionId();
    }

    withExtendedApi() {
        this.isExtended = true;
        return this;
    }

    removeExtendedApi() {
        this.isExtended = false;
    }
    getApiEndpoint(application?: any) {
        if (application == undefined || application == '') {
            application = this.getAppName();
        }
        var api_str = (this.isExtended) ? 'extended_api' : 'api';
        return this.appService.getApiEndpoint(api_str, application);
    }

    getAppName() {
        return this.appService.getApplication();
    }
    getUserType() {
        return this.authenticationService.getUserType();
    }


    checkEnfile(res, callback) {
        try {
            if (res != undefined && res.module != undefined) {
                this.translateService.getLanguage((ln) => {
                    if (!this.appService._appData.LaungFileCheckList.includes(res.module + ln + '.resource.json')) {
                        this.loaderService.showSpinner();
                        this.appService.launguageSetup(res.module, ln, (info) => {
                            if (info) {
                                callback();
                                this.loaderService.hideSpinner();
                            }
                        });
                    }
                    else {
                        callback();
                    }
                })
            }
            else {
                callback();
            }
        } catch (error) {
            callback();
            console.error("Issue while loadind launguge file from json");
        }
    }
    getResourceDefSync(resource: string): Promise<string> {
        return new Promise((resolve) => {
            this.getResourceDef(resource, (resourceDef) => {
                resolve(resourceDef);
            });
        });
    }

    getResourceDef(resource, callback) {
        if (this.appService._currentSessionData.noCodeJson != undefined && this.appService._currentSessionData.noCodeJson[resource] != undefined) {
            this.findCompositeEncrypted(this.appService._currentSessionData.noCodeJson[resource], (res) => {
                this.checkEnfile(res, () => {
                    callback(res);
                });
            });
        } else if (this.appService._currentSessionData.noCodeJsonList != undefined && (this.appService._currentSessionData.noCodeJsonList.indexOf(resource) > -1)) {
            //if there is a pending request for the same resource
            if (this.subsForNocodeForm[resource] != undefined) {
                var count = 0;
                var timeId = setInterval(() => {
                    count++;
                    console.log("PENDING GET_NOCODE_FORM REQUEST FOR SAME RESOURCE");
                    if (this.subsForNocodeForm[resource] == undefined) {
                        clearInterval(timeId);
                        if (this.appService._currentSessionData.noCodeJson[resource] != undefined) {
                            this.findCompositeEncrypted(this.appService._currentSessionData.noCodeJson[resource], (res) => {
                                delete this.subsForNocodeForm[resource];
                                this.checkEnfile(res, () => {
                                    callback(res);
                                });
                            });
                        }
                    } else {
                        if (count > 50) {
                            clearInterval(timeId);
                            //somehow not got the data yet after 5 secs.
                            callback(false);
                        }
                    }

                }, 100)
            } else {
                this.subsForNocodeForm[resource] = this.get("GET_NOCODE_FORM", "resource:" + resource, "frontend_resource", this.appService._appData.DEFAULT_APPLICATION).pipe(take(1)).subscribe(
                    (data: any) => {
                        if (data.erroCode == -1) {
                            callback(false);
                        } else {
                            if (data.resource != null && data.resource[0] != undefined && data.resource[0].frontend_json != undefined) {
                                try {
                                    this.appService._currentSessionData.noCodeJson[resource] = JSON.parse(data.resource[0].frontend_json);
                                    this.findCompositeEncrypted(this.appService._currentSessionData.noCodeJson[resource], (res) => {
                                        delete this.subsForNocodeForm[resource];
                                        this.checkEnfile(res, () => {
                                            callback(res);
                                        });
                                    });
                                } catch (e) {
                                    console.error("GET_NOCODE_FORM", resource, e);
                                    delete this.subsForNocodeForm[resource];
                                    callback(false);
                                }
                            } else {

                                delete this.subsForNocodeForm[resource];
                                callback(false);
                            }
                        }
                    }, error => {
                        delete this.subsForNocodeForm[resource];
                        callback(false);
                    })
            }

        }
        else if (this.appService._currentSessionData.dynamicJson != undefined && this.appService._currentSessionData.dynamicJson[resource] != undefined) {
            this.findCompositeEncrypted(this.appService._currentSessionData.dynamicJson[resource], (res) => {
                this.checkEnfile(res, () => {
                    callback(res);
                });
            });
        } else if (this.appService._currentSessionData.dynamicJsonList != undefined && (this.appService._currentSessionData.dynamicJsonList.indexOf(resource) > -1)) {
            //if there is a pending request for the same resource
            if (this.subsForDyanamicForm[resource] != undefined) {
                var count = 0;
                var timeId = setInterval(() => {
                    count++;
                    console.log("PENDING GET_DYNAMIC_FORM REQUEST FOR SAME RESOURCE");
                    if (this.subsForDyanamicForm[resource] == undefined) {
                        clearInterval(timeId);
                        if (this.appService._currentSessionData.dynamicJson[resource] != undefined) {
                            this.findCompositeEncrypted(this.appService._currentSessionData.dynamicJson[resource], (res) => {
                                delete this.subsForDyanamicForm[resource];
                                this.checkEnfile(res, () => {
                                    callback(res);
                                });
                            });
                        }
                    } else {
                        if (count > 50) {
                            clearInterval(timeId);
                            //somehow not got the data yet after 5 secs.
                            callback(false);
                        }
                    }

                }, 100)
            } else {
                this.subsForDyanamicForm[resource] = this.get("GET_DYNAMIC_FORM", "resource:" + resource, "form_template_mapping", this.appService._appData.DEFAULT_APPLICATION).pipe(take(1)).subscribe(
                    (data: any) => {
                        if (data.erroCode == -1) {
                            callback(false);
                        } else {
                            if (data.resource != null && data.resource[0] != undefined && data.resource[0].frontend_JSON != undefined) {
                                try {
                                    this.appService._currentSessionData.dynamicJson[resource] = JSON.parse(data.resource[0].frontend_JSON);
                                    this.findCompositeEncrypted(this.appService._currentSessionData.dynamicJson[resource], (res) => {
                                        delete this.subsForDyanamicForm[resource];
                                        this.checkEnfile(res, () => {
                                            callback(res);
                                        });
                                    });
                                } catch (e) {
                                    console.error("GET_DYNAMIC_FORM", resource, e);
                                    delete this.subsForDyanamicForm[resource];
                                    callback(false);
                                }
                            } else {
                                this.getJsonFromAssets(resource, callback);
                                delete this.subsForDyanamicForm[resource];
                                // callback(false);
                            }
                        }
                    }, error => {
                        delete this.subsForDyanamicForm[resource];
                        callback(false);
                    })
            }

        }
        else if (this.appService._appData.JSON_DEF[resource] != undefined) {
            if (this.appService._appData.JSON_DEF[resource]) {
                this.findCompositeEncrypted(this.appService._appData.JSON_DEF[resource], (res) => {
                    this.checkEnfile(res, () => {
                        callback(res);
                    });
                });
            } else {
                callback(false);
            }

        } else {
            this.getJsonFromAssets(resource, callback);
        }
    }

    getJsonFromAssets(resource, callback) {
        this._http.get('assets/json/' + resource + '.json')
            .subscribe(
                (data) => {
                    let data_ = JSON.parse(JSON.stringify(data));
                    this.findCompositeEncrypted(data_, (res) => {
                        let res_clone_current = JSON.parse(JSON.stringify(res));
                        let res_clone = JSON.parse(JSON.stringify(res));
                        this.saveJsonDef(resource, res_clone_current);
                        this.checkEnfile(res_clone, () => {
                            callback(res_clone);
                        });

                    });
                },
                err => {
                    this.saveJsonDef(resource, false);
                    callback(false);
                });
    }



    saveJsonDef(resource, def) {
        this.appService._appData.JSON_DEF[resource] = def;
    }

    getProjectionKeys(fields, projectionArray, type?) {
        let allowedArray = [];
        if (type && type != undefined) {
            allowedArray = fields;
        } else {
            for (let i = 0; i < fields.length; i++) {
                if (fields[i].name)
                    if(fields[i].name.includes('.')) {
                        allowedArray.push(fields[i].name.split('.')[0]);
                    } else{
                        allowedArray.push(fields[i].name);
                    }
            }
            allowedArray.push("id");
            allowedArray.push("tag_data"); // added in case json has taggable false then tag_data key is not shown to the user which sometime required by rule engine to perform some action
            if (this.appService.isFacilityAware())
                allowedArray.push("facility_id");
            if (this.appService.getUniversalConfig('multi_care_type'))
                allowedArray.push("care_type")

        }
        if (projectionArray && projectionArray != undefined)
            allowedArray = [...allowedArray, ...projectionArray];
        allowedArray = [...new Set(allowedArray)]; // unique array
        return allowedArray;
    }


    findCompositeEncrypted(data, callback) {
        /************** ACCOUNT AWARE ADDING FIELD **********/
        if (data.auto_column == undefined) {
            data.auto_column = {};
        }
        if (data.auto_filter == undefined) {
            data.auto_filter = {};
        }
        //if not already added in this resource
        //if current role is account aware
        //check if adding auto columns are enable on project level 
        if (data.auto_column["account_aware"] == undefined && this.appService.isFacilityAware() && this.appService.getAppData().ACCOUNT_AWARE != undefined && this.appService.getAppData().ACCOUNT_AWARE.AUTO_COLUMNS != undefined && this.appService.getAppData().ACCOUNT_AWARE.AUTO_COLUMNS.length > 0) {
            //check if its not disabled on resource level
            if (!(data.config != undefined && data.config.account_aware != undefined && data.config.account_aware.auto_columns != undefined && !data.config.account_aware.auto_columns)) {
                data.list = data.list == undefined ? [] : data.list;
                data.list.fields = data.list.fields == undefined ? [] : data.list.fields;
                data.list.fields = data.list.fields.concat(this.appService.getAppData().ACCOUNT_AWARE.AUTO_COLUMNS);
                data.auto_column["account_aware"] = true;//mark auto column added to not do this again for performance improvement
            }

            //check if its not disabled on resource level
            if (data.auto_filter["account_aware"] == undefined && !(data.config != undefined && data.config.account_aware != undefined && data.config.account_aware.auto_filters != undefined && !data.config.account_aware.auto_filters) && this.appService.getAppData().ACCOUNT_AWARE.AUTO_FILTERS != undefined && this.appService.getAppData().ACCOUNT_AWARE.AUTO_FILTERS.length > 0) {
                data.list = data.list == undefined ? [] : data.list;
                if (data.list.filter != undefined && data.list.filter.blocks != undefined && data.list.filter.blocks[0] != undefined && data.list.filter.blocks[0].fields != undefined) {
                    if (this.appService._currentSessionData.facilityArray != undefined && this.appService._currentSessionData.facilityArray.length) {
                        this.appService.getAppData().ACCOUNT_AWARE.AUTO_FILTERS[0].datasource.possible_value = this.appService._currentSessionData.facilityArray;
                    }
                    data.list.filter.blocks[0].fields = data.list.filter.blocks[0].fields.concat(this.appService.getAppData().ACCOUNT_AWARE.AUTO_FILTERS);
                    data.auto_filter["account_aware"] = true;//mark auto filter added to not do this again for performance improvement
                }
            }
        }

        //check if on json level config is there
        if (data.config != undefined && data.config.auto_columns != undefined && Array.isArray(data.config.auto_columns) && data.config.auto_columns.length > 0 && data.auto_column["json_level"] == undefined) {
            for (let index = 0; index < data.config.auto_columns.length; index++) {
                let singleAuto = data.config.auto_columns[index];
                singleAuto["getterValue"] = singleAuto["universal_config_key"];
                singleAuto["sortable"] = false;
                singleAuto["card_tag"] = null;
                singleAuto["type"] = "auto_column";
                if (singleAuto["order"] == undefined) {
                    singleAuto['order'] = data.list.fields.length - 1;
                }
                data.list = data.list == undefined ? [] : data.list;
                data.list.fields = data.list.fields == undefined ? [] : data.list.fields;
                data.list.fields = data.list.fields.concat([singleAuto]);
            }
            data.auto_column["json_level"] = true;
        }

        if (this.appService.getAppData().AUTO_COLUMNS != undefined && this.appService.getAppData().AUTO_COLUMNS.length > 0) {
            for (let index = 0; index < this.appService.getAppData().AUTO_COLUMNS.length; index++) {
                var singleAuto = this.appService.getAppData().AUTO_COLUMNS[index];
                //check if json enables this column
                // check if this is not already done
                //then check if its universal config based column
                //check if config key is provide in app config
                // check if it is enabled on  universal configration from backend
                if ((singleAuto["config_key"] != undefined && data.auto_column[singleAuto["config_key"]] == undefined && data.config != undefined && data.config[singleAuto["config_key"]] != undefined && data.config[singleAuto["config_key"]].auto_column != undefined && data.config[singleAuto["config_key"]].auto_column == true) && ((singleAuto["universal_config_enabled"] && singleAuto["universal_config_key"] != undefined && (this.appService.getUniversalConfig(singleAuto["universal_config_key"]))) || singleAuto["universal_config_enabled"] == false)) {
                    data.list = data.list == undefined ? [] : data.list;
                    data.list.fields = data.list.fields == undefined ? [] : data.list.fields;
                    data.list.fields = data.list.fields.concat([singleAuto]);
                    singleAuto['order'] = data.list.fields.length - 1;
                    data.auto_column[singleAuto["config_key"]] = true;
                }
            }

        }

        //Set Complex search as per tags
        if (data.list != undefined && data.config != undefined && !data.config.hideTagSearch && data.list.complex_search != undefined && data.list.complex_search.length != undefined && !data.list.complex_search.find(x => x.label == 'field.label.tagRow' && x.key == 'tag_data.key_value_code')) {
            data.list.complex_search.push({
                "label": "field.label.tagRow",
                "key": "tag_data.key_value_code"
            })
        }

        /************** ACCOUNT AWARE ADDING FIELD **********/
        if (data.form != undefined && data.form.blocks != undefined && data.composite_encrypted_keys == undefined) {
            this.loopBlockDef(data, JSON.parse(JSON.stringify(data.form.blocks)), () => {
                if (data.composite_encrypted_keys == undefined) {
                    data.composite_encrypted_keys = {};
                }
                callback(JSON.parse(JSON.stringify(data)));
            });

        } else {
            callback(JSON.parse(JSON.stringify(data)));
        }

    }

    loopBlockDef(data, blocks, callback) {
        if (blocks.length) {
            var singleBlock = blocks.shift();
            if (singleBlock.fields != undefined && singleBlock.fields.length) {
                this.loopFieldDef(data, singleBlock.fields, () => {
                    this.loopBlockDef(data, blocks, callback);
                });
            } else {
                this.loopBlockDef(data, blocks, callback);
            }
        } else {
            callback();
        }
    }
    loopFieldDef(data, fields, callback) {
        if (fields.length) {
            var singleField = fields.shift();
            if (singleField.type != undefined && singleField.name != undefined && singleField.type == "COMPOSITE-ARRAY" && singleField.component != undefined) {
                this.getResourceDef(singleField.component, (fieldData) => {
                    if (fieldData.encrypted_keys != undefined && fieldData.encrypted_keys.length) {
                        if (data.composite_encrypted_keys == undefined) {
                            data.composite_encrypted_keys = {};
                        }
                        console.log("composite_encrypted_keys", singleField.component);
                        data.composite_encrypted_keys[singleField.name] = fieldData.encrypted_keys;
                    }
                    this.loopFieldDef(data, fields, callback);
                })
            } else {
                this.loopFieldDef(data, fields, callback);
            }
        } else {
            callback();
        }
    }

    getReferredField(fields, callback) {
        if (fields)
            this.loopBlocks(JSON.parse(JSON.stringify(fields)), fields, 0, false, callback);
    }



    loopBlocks(blocksAr, allBlocksAr, index, prefix: any = false, callback) {
        var blocks = blocksAr.blocks;
        var allBlocks = allBlocksAr.blocks;
        var newPrefix = false;
        if (blocksAr.name != undefined) {
            newPrefix = blocksAr.name;
        } else if (blocksAr.resource != undefined) {
            newPrefix = blocksAr.resource;
        }
        if (prefix) {
            prefix = prefix + '.' + newPrefix;
        } else {
            prefix = newPrefix;
        }

        if (blocks.length) {
            var singleBlocks = blocks.shift();
            if (singleBlocks.fields != undefined && singleBlocks.fields.length) {
                this.loopFields(JSON.parse(JSON.stringify(singleBlocks.fields)), singleBlocks.fields, 0, prefix, (fields) => {
                    allBlocks[index].fields = fields;
                    allBlocks[index].block_id = (prefix) ? prefix : (allBlocks[index].name) ? allBlocks[index].name : allBlocks[index].resource;
                    index++;
                    this.loopBlocks(blocksAr, allBlocksAr, index, prefix, callback);
                });
            } else {
                index++;
                this.loopBlocks(blocksAr, allBlocksAr, index, prefix, callback);
            }
        } else {
            callback(allBlocks);
        }
    }

    loopFields(fields, allFields, index, prefix: any = false, callback) {
        if (fields.length) {
            var singleFields = fields.shift();
            if (singleFields.type == 'COMPOSITE-OBJECT') {
                this.getResourceDef(singleFields.component, (resouceDef) => {
                    if (resouceDef) {
                        allFields[index] = resouceDef.form;
                        if (singleFields.label != undefined) {
                            allFields[index].label = singleFields.label;
                        }
                        if (singleFields.name != undefined) {
                            allFields[index].name = singleFields.name;
                        } else {
                            allFields[index].resource = singleFields.component;
                        }
                        this.loopBlocks(JSON.parse(JSON.stringify(allFields[index])), allFields[index], 0, prefix, (compRes) => {
                            allFields[index].blocks = compRes;
                            index++;
                            this.loopFields(fields, allFields, index, prefix, callback);
                        });

                    } else {
                        alert('Network Error, please retry');
                        allFields[index] = {};
                        index++;
                        this.loopFields(fields, allFields, index, prefix, callback);
                    }
                });
            } else {
                if (prefix) {
                    allFields[index].name = prefix + "." + allFields[index].name;
                    if (allFields[index].proxy_name != undefined) {
                        allFields[index].proxy_name = prefix + "." + allFields[index].proxy_name;
                    }

                }
                index++;
                this.loopFields(fields, allFields, index, prefix, callback);
            }
        } else {
            callback(allFields);
        }
    }
    doPost(description) {
        return new HttpParams({ encoder: this.getHttpEncodingInstance() })
            .append('resource', description)
            .toString();
    }

    /*************** USED TO GET APPLICATION AND PERMISSIONS (DEFINED IN APP MODULE ALSO) ****/

    getMyApplication(callback) {
        if (this.getSessionId()) {
            let args = "dummy:dummy";
            if (window.location.hostname.substring(0, window.location.hostname.indexOf('.')) != 'karexpert' && window.location.hostname != 'localhost' && window.location.hostname.indexOf('admin.dvc.') == -1) {
                args += ",host_url:" + window.location.hostname;
                var account_url = this.appService.getAccountUrl();

                args += ",account_url:" + account_url;
            }
            if (this.appService._appData.SUPER_APP != undefined)
                args += ",super_app:" + this.appService._appData.SUPER_APP;
            var application = 'application_master';
            this.init(application);//TODO make it dyanamic
            this.get("GET_MY_CONFIG", args, application, this.appService._appData.DEFAULT_APPLICATION)
                .pipe(take(1))
                .subscribe(
                    (data: any) => {
                        if (data.erroCode == -1) {
                            callback([]);
                        } else {
                            if (data.resource[0].landing_url_array != undefined && data.resource[0].landing_url_array.length > 0) {
                                data.resource[0].landing_url_array.forEach(element => {
                                    if (!this.utilService.isMobile() && element.device_type_id == "web") {
                                        data.resource[0].landing_url = element.landing_url
                                        return
                                    }
                                    else if (this.utilService.isMobile() && element.device_type_id == "mobile") {
                                        data.resource[0].landing_url = element.landing_url
                                        return
                                    }
                                    else if (element.device_type_id == "all") {
                                        data.resource[0].landing_url = element.landing_url
                                    }
                                });
                            }
                            callback(data['resource'][0]);
                            //this.getEulaDocuments();
                            this.appService.setSuperApps(data['resource'][0].super_apps);
                        }
                    }, error => {
                        callback([]);
                    })
        } else {
            callback([]);
        }
    }

    getNotice(callback) {
        if (!this.appService.getNotice() && this.getSessionId() && ["system_user", "patient"].indexOf(this.authenticationService.getUserType()) == -1) {
            var resource = 'notice';
            this.get("GET_ALL_NOTICE", "", resource, this.appService._appData.DEFAULT_APPLICATION)
                .pipe(take(1))
                .subscribe(
                    (data: any) => {
                        if (data.erroCode == -1) {
                            this.appService.setNotice([]);
                            callback(true);
                        } else {
                            if (data["resource"] != undefined && data["resource"].length > 0) {
                                this.appService.setNotice(data['resource']);
                                callback(true);
                            } else {
                                this.appService.setNotice([]);
                                callback(true);
                            }
                        }
                    }, error => {
                        this.appService.setNotice([]);
                        callback(true);
                    })
        } else {
            callback(false);
        }
    }

    getMobileMenu() {
        if (this.getSessionId() && this.utilService.isMobile() && this.appService._currentSessionData.roleList != undefined && this.appService._currentSessionData.roleList.length) {
            var application = 'mobile_menu_master';
            var data: any = {};
            data.filter = "role:" + this.appService._currentSessionData.roleList[0].role;
            this.getWithPage(data, application, this.appService._appData.DEFAULT_APPLICATION, "GET_ALL").pipe(take(1))
                .subscribe(
                    (data: any) => {
                        if (data.erroCode == -1) {

                        } else {
                            if (data.resource.length && data.resource[0].fields) {
                                this.appService._currentSessionData.mobileMenu = data.resource[0].fields;
                            }

                        }
                    }, error => {
                    })
        } else {
        }

    }

    base64ToArrayBuffer(base64: string) {
        const parts = base64.split(';base64,');
        const contentType = parts[0].split(':')[1];
        const raw = window.atob(parts[1]);
        const rawLength = raw.length;
        const uint8Array = new Uint8Array(new ArrayBuffer(rawLength));
        for (let i = 0; i < rawLength; ++i) {
            uint8Array[i] = raw.charCodeAt(i);
        }
        return new Blob([uint8Array], { type: contentType });
    }

    getEulaDocuments() {
        this.get("GET_EULA_LINKS", "", "eula_document", "dms")
            .pipe(take(1))
            .subscribe(
                (data: any) => {
                    if (data.erroCode != -1) {
                        this.appService.parseEula(data['resource']);
                    }
                });
    }

    /*************** USED TO GET APPLICATION AND PERMISSIONS ****/

    /**
     * Converting array Buffer tO BASE64
     */
    arrayBufferToBase64(buffer) {
        var binary = '';
        var bytes = new Uint8Array(buffer);
        var len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }
    /**
    * Getting File Data from Api On the Basis Of the File URL
    * Passing Two parameter File ID and Resource 
    */
    getfileDataFromURL(file_url, resource) {
        let selectedFiles = [];
        this.loaderService.showSpinner();
        let promise = new Promise((resolve, reject) => {
            let url = '/dms/api/v1/' + resource + '/image-response-entity?path=' + file_url;
            this.getFileByUrl(url, false).toPromise().then(data => {
                if (data) {
                    this.loaderService.hideSpinner();
                    if (data && data.errCode != -1) {
                        let contentType = 'data:' + data.type + ';base64, ';
                        let imagebase64 = contentType + data.imageData;
                        const fileVal = {
                            imageSrc: imagebase64,
                            file: {
                                size: data.size,
                                contentType: data.type
                            }
                        };
                        selectedFiles.push(fileVal);
                        resolve(selectedFiles);
                    } else {
                        console.error("Server Failed while getting File Data");
                    }
                }
            });
        });
        return promise;
    }

    /**
    * Getting File Data from Api On the Basis Of the File
    * Passing Two parameter File ID and Resource 
    */

    getfileData(file_id, resource) {
        let selectedFiles = [];
        let documentResource = resource + '/image-byte-array';
        this.loaderService.showSpinner();
        let promise = new Promise((resolve, reject) => {
            this.get(file_id, "", documentResource, 'dms').toPromise().then(
                (data: any) => {
                    this.loaderService.hideSpinner();
                    if (data && data.errCode != -1) {
                        let contentType = 'data:' + data.contentType + ';base64, ';
                        let imagebase64 = contentType + data.imageData;
                        const fileVal = {
                            imageSrc: imagebase64,
                            file: {
                                name: data.documentName,
                                size: data.size,
                                contentType: data.contentType
                            }
                        };
                        selectedFiles.push(fileVal);
                        resolve(selectedFiles);
                    } else {
                        console.error("Server Failed while getting File Data");
                    }
                },
                err => {
                    console.error("Server Failed while getting File Data");
                });
        });
        return promise;
    }


    getFile(config) {
        let apiAction = config != undefined && config.action != undefined && config.action ? config.action : 'print';
        if (config.responseType) {
            if (config.action == "print-async") {
                config.resource += '/print-async';
            } else {
                config.resource += '/print';
            }
            let obj = { queryId: (this.setQueryId(config)) ? this.setQueryId(config) : 'print', args: config.args, filter: (config.filter != undefined) ? config.filter : '', filterPrintInfo: (config.filterPrintInfo != undefined) ? config.filterPrintInfo : false, template: (config.template != undefined) ? config.template : '', responseType: config.responseType != undefined ? config.responseType : "", contentType: config.contentType != undefined && config.contentType ? config.contentType : "pdf", print_doc_details: (config.print_doc_details != undefined && config.print_doc_details.length > 0) ? config.print_doc_details : undefined, };
            return this.action(obj, apiAction, config.application, config.resource, '', { responseType: config.responseType });
            // action(_resource, action, application?, resource?, bpmn_action?, responseType?)
            // return this.get( config.application, (config.filter != undefined) ? config.filter : '', { responseType: config.responseType });
        } else {
            return this.get(this.setQueryId(config) ? this.setQueryId(config) : 'print', config.args, config.resource, config.application, (config.filter != undefined) ? config.filter : '');
        }
    }
    appendEhrFacilityIdArg(args, rootData?) {
        const data = rootData?.data ?? rootData;
        const ehrFacilityID = data?.facility_id ?? data?.facility_id;

        if (!ehrFacilityID) {
            return args;
        }

        if (args == undefined || args === false || args === "") {
            return `ehrFacilityID:${ehrFacilityID}`;
        }

        if (typeof args !== "string" || args.includes("ehrFacilityID:")) {
            return args;
        }

        return `${args},ehrFacilityID:${ehrFacilityID}`;
    }
    setQueryId(config) {
        if (config.query_id != undefined) {
            return config.query_id;
        }
        else if (config.queryId != undefined) {
            return config.queryId;
        }
        else {
            false;
        }
    }

    getExtensionbyMimeType(type) {
        var mimeTypes = { "video/3gpp2": ".3gp2", "video/3gpp": ".3gpp", "application/x-7z-compressed": ".7z", "video/x-msvideo": ".avi", "text/csv": ".csv", "text/dlm": ".dlm", "application/msword": ".dot", "application/vnd.openxmlformats-officedocument.wordprocessingml.document": ".docx", "text/html": ".html", "application/java-archive": ".jar", "image/jpeg": ".jpeg", "application/x-javascript": ".js", "application/json": ".json", "text/jscript": ".jsx", "video/quicktime": ".mov", "audio/mpeg": ".mp3", "video/mp4": ".mp4", "application/pdf": ".pdf", "image/png": ".png", "application/vnd.openxmlformats-officedocument.presentationml.slideshow": ".ppsx", "application/vnd.ms-powerpoint": ".ppt", "application/xml": ".skin", "text/plain": ".txt", "audio/wav": ".wave", "application/vnd.ms-excel": ".xlt", "application/vnd.ms-excel.sheet.binary.macroEnabled.12": ".xlsb", "application/vnd.ms-excel.sheet.macroEnabled.12": ".xlsm", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": ".xlsx", "text/xml": ".xml", "application/x-zip-compressed": ".zip" };
        return (mimeTypes[type] != undefined) ? mimeTypes[type] : ".txt";
    }

    getCachedFileByUrl(url, secure = true, responseType = 'blob', cache: boolean = true) {
        var cacheKey: any = false;
        if (cache) {
            cacheKey = CryptoJS.MD5(url).toString();
            const data = this.getCachedData(cacheKey)
            if (data) {
                return of((secure)? this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(data.body)): data.body
                );
            }
        }
        return this.httpGet(url, false, { responseType: responseType })
            .pipe(map(val => {
                if (cacheKey) {
                    this.setCachedData(cacheKey, val)
                }
                return (secure) ? this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(val.body)) : val.body
            }
            ));
    }

    getFileByUrl(url, secure = true, responseType = 'blob') {
        return this.httpGet(url, false, { responseType: responseType })
            .pipe(map(val => {
                return (secure) ? this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(val.body)) : val.body
            }
            ));
    }
    getFileByUrlWithHeader(url, secure = true) {
        return this.httpGet(url, false, { responseType: 'blob' })
            .pipe(map(val => {
                return (secure) ? this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(val.body)) : val
            }
            ));
    }


    /**
     * Ask DMS for a short-lived URL pointing straight at object storage, instead of
     * streaming the document's bytes through the service.
     *
     * Sibling of getFileByUrl above, and the right call for large media. That one
     * fetches through `image-response-entity`, which buffers the whole object into
     * DMS heap, holds a request thread for the transfer and cannot answer a Range
     * request -- so a video player cannot seek without refetching from byte 0. Here
     * DMS authorizes once and the store does the delivery, Range included.
     *
     * The returned `url` is a bearer capability that expires at `expires_at`
     * (absolute, epoch millis), so callers must re-request rather than cache it.
     *
     * Response shape: `{ errCode, message, url, expires_at, content_type,
     * file_name, size, adaptor }`, with `errCode: -1` on any refusal -- DMS cannot
     * sign encrypted documents or clusters on adaptors without signing support, and
     * callers are expected to fall back to getFileByUrl in that case.
     *
     * Both halves of the XSRF scheme apply. httpGet computes the request token over
     * the query string; the response token is verified below rather than by
     * decryptResponse, because `currentResource` is false here (as in the two
     * methods above -- a DMS document type is not a frontend resource, so there is
     * no resource definition to look up). Verification matters more on this call
     * than on an ordinary read: the body carries a URL, and a substituted one would
     * point the player at another host.
     */
    getDocumentSignedUrl(documentId: string, documentType: string, ttlMinutes?: number) {
        const query = 'id=' + encodeURIComponent(documentId)
            + (ttlMinutes ? '&ttlMinutes=' + ttlMinutes : '')
            + '&application=dms';
        const url = this.getApiEndpoint('dms') + documentType + '/signed-url?' + query;
        // No responseType override: addGetXsrfToken already asks for text +
        // observe:'response', which is what keeps the raw body available to hash and
        // the headers available to read.
        return this.httpGet(url, false, {})
            .pipe(map((response: any) => {
                const raw = (response && response.body != undefined) ? response.body : response;
                const bodyStr = (typeof raw === 'string') ? raw : JSON.stringify(raw);
                const serverToken = (response && response.headers) ? response.headers.get('x-xsrf-token') : null;
                // Absent token means DMS could not derive one (an internal call, or
                // no session key). Nothing to compare against, so nothing to reject.
                if (serverToken) {
                    const uiToken = this.appService.getXsrfToken(bodyStr, true);
                    if (uiToken != serverToken) {
                        console.error("BAD RESPONSE", url);
                        return { errCode: -1, message: "BAD RESPONSE" };
                    }
                }
                try {
                    return (typeof raw === 'string') ? JSON.parse(raw) : raw;
                } catch (e) {
                    console.error("BAD RESPONSE (unparseable)", url, e);
                    return { errCode: -1, message: "BAD RESPONSE" };
                }
            }));
    }
    handleFile(fileObj, callback) {
        var args = "";
        console.log("Handle fileObj::", fileObj);

        // fileObj.responseType = false;
        if (fileObj.contentType != 'byte_array') {
            if (fileObj.responseType == 'application/text') { }
            else
                fileObj.responseType = "blob";
            var args = "reportTemplateId:" + fileObj.template + ",contentType:" + fileObj.contentType;
            //cumulative print
            if (fileObj.cumulativeInfo != undefined) {
                args += ",cumulativeInfo:" + fileObj.cumulativeInfo;
            }
        }

        if (fileObj.args != undefined && fileObj.args) {
            args += ((args == '') ? '' : ',') + fileObj.args;
        }
        if (fileObj.contentType != undefined && fileObj.contentType) {
            fileObj.contentType = fileObj.contentType;
        }
        fileObj.args = args;
        this.getFile(fileObj)
            .pipe(take(1))
            .subscribe(
                (res: any) => {
                    if (fileObj.contentType == 'byte_array') {
                        if (res.resource != null && res.resource[0] != undefined) {
                            callback(res.resource[0]);
                        } else {
                            callback(false);
                        }
                    } else {
                        callback(res);
                    }

                },
                err => {
                    callback(false);
                    console.error("Server Failed while getting File Data");
                });
    }

    nativeFileHandling(blob, type, fileName) {
        if (fileName == undefined) {
            fileName = "document" + this.getExtensionbyMimeType(type);
        }
        this.utilService.downloadFile(blob, type, fileName);
    }

    nativeUrlHandling(url) {
        var argsNative = { url: url };
        window.flutter_inappwebview.callHandler('openUrl', ...[argsNative]);
    }

    async nativeDataHandling(type, data) {
        return await this.appService.nativeDataHandling(type, data);
    }

    async getGeoLocation() {
        var resp = await this.nativeDataHandling("get_location", {});
        try {
            return JSON.parse(resp);
        } catch (e) {
            return {}
        }
    }

    downloadFile(fileData, type, fileName, callback = null) {
        this.utilService.downloadFile(fileData, type, fileName, callback);
    }
    base64ToBlob(base64, contentType) {
        // Remove the data URL part (if it exists)
        const base64WithoutPrefix = base64.replace(/^data:image\/(png|jpeg|svg\+xml);base64,/, '');

        // Decode the base64 string
        const byteCharacters = atob(base64WithoutPrefix);

        // Create an array of 8-bit unsigned integers
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);

        // Create a blob from the byte array
        return new Blob([byteArray], { type: contentType });
    }
    viewFile(fileData, type, fileName, callback = null) {
        var blob = new Blob([fileData], { type: type });
        var blob = new Blob([fileData], { type: type });
        if (this.appService.checkNativeApp()) {
            this.nativeFileHandling(blob, type, fileName);
        } else {
            var url = window.URL.createObjectURL(blob);
            if (this.utilService.isiOS()) {
                //if its a mobile
                this.printMobile(url)
                if (callback != null) {
                    callback(true);
                }
            }
            else {
                var w = window.open(url);
                setTimeout(() => {
                    if (w && w.document == undefined && /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)) {
                        alert("If you have Ad block installed Please disable Ad block for this website to view the file");
                    }
                }, 1000);
                if (callback != null) {
                    callback(true);
                }
            }
        }

    }
    async printFile(fileData, type, fileName, callback = null, no_of_print_copy?) {
        if (type == 'application/xlsx') {
            this.downloadFile(fileData, type, fileName, callback);
            return;
        }
        var blob = new Blob([fileData], { type: type });
        if (this.appService.checkNativeApp()) {
            this.nativeFileHandling(blob, type, fileName);
        } else {
            let isPasswordProtectedPdf = false;
            if (type === 'application/pdf') {
                isPasswordProtectedPdf = await this.isPasswordProtectedPdf(blob);
            }

            let url;
            if (no_of_print_copy && !isPasswordProtectedPdf) {
                const mergedPdfBlob = await this.mergePdf(blob, no_of_print_copy);
                url = window.URL.createObjectURL(mergedPdfBlob);
            }
            else {
                url = window.URL.createObjectURL(blob);
            }

            if (isPasswordProtectedPdf) {
                window.open(url);
                if (callback != null) {
                    callback(true);
                }
            } else if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
                var w = window.open(url);
                setTimeout(() => {
                    if (w) {
                        w.print();
                        //commented as it closes the window ongo
                        // w.close();
                    }
                }, 1000);

                if (callback != null) {
                    callback(true);
                }

            } else if (this.utilService.isMobile()) {
                //if its a mobile
                this.printMobile(url)
                if (callback != null) {
                    callback(true);
                }
            } else {
                var iframe = document.createElement('iframe');
                iframe.className = 'pdfIframe'
                document.body.appendChild(iframe);
                iframe.style.display = 'none';
                iframe.onload = function () {
                    setTimeout(function () {
                        iframe.focus();
                        iframe.contentWindow.print();
                        URL.revokeObjectURL(url)
                        // document.body.removeChild(iframe);
                        blob = null;
                    }, 1);
                };
                iframe.src = url;
                if (callback != null) {
                    callback(iframe);
                }
            }
        }

    }

    async isPasswordProtectedPdf(blob: Blob): Promise<boolean> {
        try {
            await PDFDocument.load(await blob.arrayBuffer());
            return false;
        } catch (error) {
            const message = (error && error.message) ? String(error.message).toLowerCase() : "";
            return message.indexOf('encrypted') > -1 || message.indexOf('password') > -1;
        }
    }

    async mergePdf(blob: Blob, no_of_print_copy: any) {
        // Load the existing PDF
        const pdfDoc = await PDFDocument.load(await blob.arrayBuffer());

        // Create a new PDF document for the merged result
        const mergedPdfDoc = await PDFDocument.create();

        // Get all the pages from the original PDF and duplicate them
        const copiedPages = await mergedPdfDoc.copyPages(pdfDoc, pdfDoc.getPages().map((_, index) => index));

        // You can duplicate the pages multiple times
        for (let i = 0; i < no_of_print_copy; i++) {  // Adjust the count here for how many times to duplicate
            copiedPages.forEach(page => mergedPdfDoc.addPage(page));
        }
        // Serialize the merged PDF to a byte array
        const mergedPdfBytes = await mergedPdfDoc.save();
        return new Blob([mergedPdfBytes], { type: 'application/pdf' });
    }


    /************ HANDLE TITLE *******************/

    setTitleFromResouceDef(resourceDef, action) {
        var title = '';
        if (resourceDef.page_name != undefined) {
            if (action === 'LIST')
                title = resourceDef.page_name.list != undefined ? resourceDef.page_name.list : "";
            else if (action === 'ADD')
                title = resourceDef.page_name.add != undefined ? resourceDef.page_name.add : "";
            else if (action === 'MODIFY')
                title = resourceDef.page_name.edit != undefined ? resourceDef.page_name.edit : "";
            else if (action === 'VIEW')
                title = resourceDef.page_name.view != undefined ? resourceDef.page_name.view : "";
            else if (action === 'IMAGE_VIEWER')
                title = resourceDef.page_name.list != undefined ? resourceDef.page_name.list : "";
            else if (action === 'EDITGRID')
                title = resourceDef.page_name.list != undefined ? resourceDef.page_name.list : "";
        }

        this.setTitle(title);
    }

    setTitleFromResouce(resource, action) {
        this.getResourceDef(resource, (resourceDef) => {
            if (resourceDef) {
                this.setTitleFromResouceDef(resourceDef, action)
            } else {
                this.setTitle('');
            }
        });

    }
    setTitle(title: string) {
        if (title) {
            this.translatePipe.transform(title)
                .pipe(take(1))
                .subscribe(
                    (res) => {
                        if (res) {
                            this._currentTitle = res;
                            this.titleService.setTitle(this._currentTitle);
                        } else {
                            this.setDefaultTitle();
                        }

                    },
                    (error) => this.setDefaultTitle()
                );

        } else {
            // this.setDefaultTitle();
        }
    }

    setDefaultTitle() {
        this._currentTitle = this.appService._appData.APPLICATION_NAME;
        this.titleService.setTitle(this._currentTitle);
    }
    asyncLanguageProcess(label, returnDefault = false) {
        return new Promise((resolve, reject) => {
            this.translatePipe.transform(label)
                .pipe(take(1))
                .subscribe(
                    (res) => {
                        if (res) {
                            resolve(res);
                        } else {
                            if (returnDefault) {
                                resolve(label);
                            } else {
                                resolve('');
                            }
                        }

                    },
                    (error) => {
                        if (returnDefault) {
                            resolve(label);
                        } else {
                            resolve('');
                        }
                    }
                );

        });
    }

    asyncMenuLanguageProcess(item: any) {
        var item_trans = "";
        var trans_key = item.name_translation_key ? item.name_translation_key : item.name;
        return new Promise((resolve, reject) => {
            this.translatePipe.transform(trans_key)
                .pipe(
                    map((tran_text) => {
                        if (tran_text) {
                            if (tran_text.includes("menu.")) {
                                item_trans = item.name;
                            } else {
                                item_trans = tran_text;
                            }
                        }
                        return item_trans;
                    })
                ).subscribe(
                    (res) => {
                        if (res) {
                            resolve(res);
                        } else {
                            resolve(trans_key)
                        }

                    },
                    (error) => {
                        resolve(trans_key)
                    }
                );;

        });
    }
    /************ HANDLE TITLE *******************/

    /************ HANDLE TIME *******************/
    handleTimeRange(str, time) {
        switch (time.type) {
            case "custom":
                if (str.indexOf('!!!from!!!') > -1) {
                    str = str.replace('!!!from!!!', moment().add(parseInt(time.count), time.range_type).format('YYYY-MM-DD'));
                } else {
                    str += ((str == '') ? '' : ',') + 'from:' + moment().add(parseInt(time.count), time.range_type).format('YYYY-MM-DD');
                }

                if (str.indexOf('!!!to!!!') > -1) {
                    str = str.replace('!!!from!!!', moment().format('YYYY-MM-DD'));
                } else {
                    str += ((str == '') ? '' : ',') + 'to:' + moment().format('YYYY-MM-DD');
                }
                return str;
                break;
            case "today":
                var moment_date = moment();
                if (time.range_type == 'yearly') {
                    str += ((str == '') ? '' : ',') + 'year:' + moment_date.format('YYYY');
                } else if (time.range_type == 'monthly') {
                    str += ((str == '') ? '' : ',') + 'month:' + moment_date.format('MM') + ',year:' + moment_date.format('YYYY');
                } else if (time.range_type == 'date') {
                    str += ((str == '') ? '' : ',') + 'date_filter:' + moment_date.startOf('day').valueOf();
                } else {
                    str += ((str == '') ? '' : ',') + 'day:' + moment_date.format('DD') + ',month:' + moment_date.format('MM') + ',year:' + moment_date.format('YYYY');
                }

                return str;
                break;
            case "yesterday":
                var moment_date = moment().subtract(1, 'days',);
                if (time.range_type == 'yearly') {
                    str += ((str == '') ? '' : ',') + 'year:' + moment_date.format('YYYY');
                } else if (time.range_type == 'date') {
                    str += ((str == '') ? '' : ',') + 'date_filter:' + moment_date.format('YYYY-MM-DD');
                } else if (time.range_type == 'monthly') {
                    str += ((str == '') ? '' : ',') + 'month:' + moment_date.format('MM') + ',year:' + moment_date.format('YYYY');
                } else {
                    str += ((str == '') ? '' : ',') + 'day:' + moment_date.format('DD') + ',month:' + moment_date.format('MM') + ',year:' + moment_date.format('YYYY');
                }
                return str;
                break;
            default:
                break;
        }
    }

    getCurrentDate() {
        var date = moment();
        return +date;
    }
    getPreviousDate() {
        var date = moment().startOf('day').subtract(1, 'days');
        return +date;
    }
    getTodayMillis() {
        var date = moment().startOf('day');
        return +date;
    }

    getTodayEndMillis() {
        var date = moment().endOf('day');
        return +date;
    }

    createComponent(selector, reference, callback) {
        var factories: any = this.getFactories();
        //const factoryClass:any = factories.find((x: any) => x.selector ===  singleRoute.data.selector);
        if (factories != undefined && factories[selector] != undefined && factories[selector]) {
            const componentFactory = this._componentFactoryResolver.resolveComponentFactory(factories[selector]);
            let component = reference.createComponent(componentFactory);
            if (component) {
                callback(component);
            } else {
                callback(false);
            }
        } else {
            callback(false);
        }
    }


    getFactories() {
        return this.appService._factories["components"];
    }
    /************ HANDLE TIME *******************/

    /****************** DYANAMIC STRING CREATION *****/

    // buildDyanamicStr(str, self) {
    //     var finalStr = str;
    //     const regex = /\!!!(.*?)\!!!/gm;
    //     let m;
    //     while ((m = regex.exec(str)) !== null) {
    //         // This is necessary to avoid infinite loops with zero-width matches
    //         if (m.index === regex.lastIndex) {
    //             regex.lastIndex++;
    //         }
    //         for (let match of m) {
    //             if (self.data != undefined && self.data[match] != undefined) {
    //                 // if string is html i.e. type multirow- specially written for emr - old glass record and refraction case
    //                 if (self.type != undefined && self.type == "html") {
    //                     let key = JSON.parse(JSON.stringify(self.data[match]));
    //                     try {

    //                         if (key.indexOf('<') != -1) {
    //                             key = key.replace('<', "&lt;")
    //                         }
    //                         else if (key.indexOf('>') != -1) {
    //                             key = key.replace('>', "&gt;")
    //                         }

    //                     } catch (error) {
    //                         // do nothing
    //                     }
    //                     finalStr = finalStr.replace('!!!' + match + '!!!', key);
    //                 }
    //                 //this works for the all normal cases
    //                 else { finalStr = finalStr.replace('!!!' + match + '!!!', self.data[match]); }

    //             }  else if (self.data !== undefined && self.data !== null && (self.data[match] === undefined || self.data[match] === null) && self.type === "html") {
    //                 let key = match.replace(/!!!/g, '');
    //                 let value = this.getMultiRowValue(self.data, key);
    //                 if (value !== undefined && value !== null) {
    //                     if (self.type === "html") {
    //                         try {
    //                             value = value.toString().replace(/</g, "&lt;").replace(/>/g, "&gt;");
    //                         } catch (error) {
    //                             console.error("Error sanitizing value:", error);
    //                         }
    //                     }
    //                     finalStr = finalStr.replace('!!!' + match + '!!!', value);
    //                 }
    //             }
    //             else if (self.form != undefined && self.form.controls != undefined && self.form.controls[match] != undefined) { //this is sepecific case in case of form
    //                 finalStr = finalStr.replace('!!!' + match + '!!!', self.form.controls[match].value);
    //             } else if (match == 'application') { // Sanjay: code review is required for this condition
    //                 finalStr = finalStr.replace('!!!' + match + '!!!', this.getAppName());
    //             } else if (this.appService.getCurrentLocation() && match == 'location_id') {
    //                 finalStr = finalStr.replace('!!!' + match + '!!!', this.appService.getCurrentLocation().location_id);
    //             } else if (this.getTodayMillis() && match == 'start_today') {
    //                 finalStr = finalStr.replace('!!!start_today!!!', this.getTodayMillis());
    //             } else if (this.getPreviousDate() && match == 'previous_date') {
    //                 finalStr = finalStr.replace('!!!previous_date!!!', this.getPreviousDate());
    //             } else if (this.getCurrentDate() && match == 'current_date') {
    //                 finalStr = finalStr.replace('!!!current_date!!!', this.getCurrentDate());
    //             } else if (this.getTodayEndMillis() && match == 'end_today') {
    //                 finalStr = finalStr.replace('!!!end_today!!!', this.getTodayEndMillis());
    //             } else if (match == 'facility_id') {
    //                 finalStr = finalStr.replace('!!!facility_id!!!', this.appService.getOrganization().org_id)
    //             } else if (match == 'uhId') {
    //                 finalStr = finalStr.replace('!!!uhId!!!', this.getpatientUhid())
    //             } else if (match == 'resource') {
    //                 finalStr = finalStr.replace('!!!resource!!!', this._resourceName)
    //             } else if (match == 'userId') {
    //                 finalStr = finalStr.replace('!!!userId!!!', this.authenticationService.getCurrentUser().user_id)
    //             } else if (match == 'first_name') {
    //                 finalStr = finalStr.replace('!!!first_name!!!', this.authenticationService.getCurrentUser().first_name)
    //             }
    //             else if (match == 'Last30Days') {
    //                 finalStr = finalStr.replace('!!!Last30Days!!!', moment().subtract(29, 'days').startOf('day').valueOf());
    //             } else {
    //                 finalStr = finalStr.replace('!!!' + match + '!!!', ""); //replacing with empty value
    //             }
    //         }
    //     }
    //     return finalStr
    // }
    buildDyanamicStr(str, self) {
        var finalStr = str;
        const regex = /\!!!(.*?)\!!!/gm;
        let m;
        while ((m = regex.exec(str)) !== null) {
            if (m.index === regex.lastIndex) {
                regex.lastIndex++;
            }

            const fullMatch = m[0]; // e.g., "!!!currentTreatingDoctorId?currentTreatingDoctorId:doctor_id!!!"
            const expression = m[1]; // e.g., "currentTreatingDoctorId?currentTreatingDoctorId:doctor_id"

            let value = '';

            // Handle ternary-like conditional: "condition?trueValue:falseValue"
            if (expression.includes('?') && expression.includes(':')) {
                const [condition, result] = expression.split('?');
                const [trueKey, falseKey] = result.split(':');

                const conditionValue = self.data?.[condition] ?? this.getSpecialValue(condition, self);
                value = (conditionValue !== undefined && conditionValue !== null && conditionValue !== '')
                    ? (self.data?.[trueKey] ?? this.getSpecialValue(trueKey, self) ?? '')
                    : (self.data?.[falseKey] ?? this.getSpecialValue(falseKey, self) ?? '');
            } else {
                value = self.data?.[expression] ?? this.getSpecialValue(expression, self) ?? '';
            }

            // Sanitize if HTML type
            if (self.type === "html" && typeof value === 'string') {
                try {
                    value = value.toString().replace(/</g, "&lt;").replace(/>/g, "&gt;");
                } catch (e) {
                    // ignore
                }
            }
            finalStr = finalStr.replace(fullMatch, typeof value === 'string' ? JSON.stringify(value).slice(1, -1) : value);
            finalStr = finalStr.replace(fullMatch, value);
        }
        return finalStr;
    }

    // Helper for special case fallback keys
    getSpecialValue(key, self) {
        try {
            switch (key) {
                case 'application': return this.getAppName();
                case 'location_id': return this.appService.getCurrentLocation()?.location_id;
                case 'start_today': return this.getTodayMillis();
                case 'end_today': return this.getTodayEndMillis();
                case 'previous_date': return this.getPreviousDate();
                case 'current_date': return this.getCurrentDate();
                case 'facility_id': return this.appService.getOrganization()?.org_id;
                case 'uhId': return this.getpatientUhid();
                case 'resource': return this._resourceName;
                case 'userId': return this.authenticationService.getCurrentUser()?.user_id;
                case 'first_name': return this.authenticationService.getCurrentUser()?.first_name;
                case 'Last30Days': return moment().subtract(29, 'days').startOf('day').valueOf();
                default:
                    if (self.form?.controls?.[key]) {
                        return self.form.controls[key].value;
                    }
                    // Handle multirow in HTML
                    if (self.type === "html") {
                        const value = this.getMultiRowValue(self.data, key);
                        if (value !== undefined && value !== null) {
                            return value.toString().replace(/</g, "&lt;").replace(/>/g, "&gt;");
                        }
                    }
                    return null;
            }
        } catch (e) {
            return null;
        }
    }


    getMultiRowValue(obj, key) {
        let value = obj;
        key.split('.').forEach(key => {
            if (value && value[key] !== undefined) {
                value = value[key];
            } else {
                value = '';
            }
        });
        return value;
    }


    getParameters(url, userObj) {
        return this.appService.getParameters(url, userObj);
    }

    getpatientUhid() {
        return localStorage.getItem("hasUhId");
    }

    reloadCurrentRoute() {
        let currentUrl = this.router.url;
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigateByUrl(currentUrl);
    }


    initDecorator(decorator: any, route: any, injector?) {
        var decoratorClass: any = false;
        if (this.appService._appData.DECORATOR_DEF != undefined && this.appService._appData.DECORATOR_DEF[decorator] != undefined) {
            console.info("decorator found======>", decorator);
            try {
                decoratorClass = new this.appService._appData.DECORATOR_DEF[decorator](route, decorator, injector);
                decoratorClass.init();
            } catch (e) {
                decoratorClass = false;
                console.error("decorator load error ==>", e);
            }
        } else {
            console.error("decorator not found");
        }
        return decoratorClass;
    }

    _careTypeFilter(resourceDef, permssion) {
        //sauravdeep added filter
        if (resourceDef.config != undefined && this.appService.getUniversalConfig("multi_care_type") && this.appService.getUniversalConfig("care_type").length != 0 && resourceDef.config.care_type != undefined && resourceDef.config.care_type[permssion] != undefined && resourceDef.config.care_type[permssion] == true) {
            return true
        } else {
            return false
        }
    }

    /************FOR DECRYPTION ****/
    private decryptResponse(resource, response: any, config) {

        if (config.options != undefined && config.options.responseType != undefined && config.options.responseType == "application/text") {
            var xsrfToken = response.headers.get("x-xsrf-token");
            var uiToken
            return new Promise<any>((resolve, reject) => {
                uiToken = this.appService.getXsrfToken(response.body, true)
                resolve(this.synchDecrypt(response, resource, xsrfToken, uiToken, config));
            });
        }
        var xsrfToken = response.headers.get("x-xsrf-token");
        var uiToken
        return new Promise<any>((resolve, reject) => {
            this.getResourceDef(resource, (res: any) => {
                if (res && res.login_required != undefined) {
                    uiToken = this.appService.getXsrfToken(response.body, res.login_required);
                } else {
                    uiToken = this.appService.getXsrfToken(response.body, true)
                }
                resolve(this.synchDecrypt(response, resource, xsrfToken, uiToken, config));
                // return new Promise<any>((resolve, reject) => {
                //     resolve(resCom);
                // });
            })
        });



    }

    synchDecrypt(response, resource, xsrfToken, uiToken, config) {
        var result: any = {};
        if (typeof response.body == "string") {
            if (config && config.options != undefined && config.options.responseType != undefined && config.options.responseType == 'application/text' && resource.includes("/print")
            ) {
                return new Promise<any>((resolve, reject) => {
                    if (uiToken != xsrfToken) {
                        result.errCode = -1;
                        result.message = "BAD RESPONSE";
                        delete result.resource;
                        this.showApiError(result.message);
                        console.error("BAD RESPONSE", resource);
                        resolve(result);
                    } else {
                        resolve(response.body);
                    }
                });
            } else {
                try {
                    result = JSON.parse(response.body);
                } catch (e) {
                    result.errCode = -1;
                    result.message = "BAD RESPONSE";
                    delete result.resource;
                    console.error(e);
                    console.error("BAD JSON RESPONSE", resource);
                    return new Promise<any>((resolve, reject) => {
                        resolve(result);
                    });

                }
            }

        } else {
            result = response.body;
        }


        console.log("xsrfToken", xsrfToken);
        console.log("uiToken", uiToken);
        console.log("config", config);

        return new Promise<any>((resolve, reject) => {
            if (result.errCode == -1 && result.message == undefined) {
                result.message = 'Sorry, something went wrong. Refresh the page and try again. Contact your IT support if issue persists';
                resolve(result);
            } else if (result.errCode == -1 && (result.message == 'Invalid Session' || result.message == 'Session expired')) {
                console.log('error login');
                const currentUser = this.authenticationService.currentUserValue;
                if (currentUser) {
                    this.showApiError(result.message);
                }
                this.logout();
            } else if (result.errCode == -2) {
                this.showApiError(result.message);
                resolve(result);
            } else if (result.errCode == -9) {
                this.alertsService.successWithMessage("", result.message);
                resolve(result);
            } else {
                if (uiToken != xsrfToken && !(response.body instanceof Blob)) {
                    result.errCode = -1;
                    result.message = "BAD RESPONSE";
                    delete result.resource;
                    this.showApiError(result.message);
                    console.error("BAD RESPONSE", resource);
                    resolve(result);
                }
                if (result.resource != null && result.resource[0] != undefined) {
                    if (this.authenticationService.getEnryptionKey()) {
                        this.getResourceDef(resource, (resourceDef) => {
                            if (resourceDef) {
                                if ((resourceDef.encrypted_keys != undefined && resourceDef.encrypted_keys.length) || (resourceDef.composite_encrypted_keys != undefined && Object.keys(resourceDef.composite_encrypted_keys).length)) {
                                    for (let singleResource of result.resource) {
                                        if (resourceDef.encrypted_keys != undefined && resourceDef.encrypted_keys.length) {
                                            for (let key of resourceDef.encrypted_keys) {
                                                let val = get(singleResource, key);
                                                if (val != undefined) {
                                                    set(singleResource, key, this.decryptText(this.authenticationService.getEnryptionKey(), val));
                                                }
                                            }
                                        }

                                        /************** COMPOSITE KEY DECRYPTION ****************/
                                        if (resourceDef.composite_encrypted_keys != undefined && Object.keys(resourceDef.composite_encrypted_keys).length) {
                                            for (let key in resourceDef.composite_encrypted_keys) {
                                                if (get(singleResource, key) && Array.isArray(get(singleResource, key)) && get(singleResource, key).length) {
                                                    for (let index = 0; index < get(singleResource, key).length; index++) {
                                                        var singleObj = get(singleResource, key)[index];
                                                        if (resourceDef.composite_encrypted_keys[key].length) {
                                                            for (let encyKey of resourceDef.composite_encrypted_keys[key]) {
                                                                let val = get(singleObj, encyKey);
                                                                if (val != undefined) {
                                                                    set(singleObj, encyKey, this.decryptText(this.authenticationService.getEnryptionKey(), val));
                                                                }
                                                            }
                                                        }

                                                    }
                                                }
                                            }
                                        }
                                        /************** COMPOSITE KEY DECRYPTION ****************/

                                    }
                                    resolve((config.single != undefined && config.single) ? result.resource[0] : result);
                                } else {
                                    resolve((config.single != undefined && config.single) ? result.resource[0] : result);
                                }

                            } else {
                                resolve((config.single != undefined && config.single) ? result.resource[0] : result);
                            }
                        });
                    } else {
                        resolve((config.single != undefined && config.single) ? result.resource[0] : result);
                    }


                } else {
                    resolve(result);
                }
            }

        })
    }

    logout() {
        this.storageService.reloadOtherTab();
        this.authenticationService.logout(() => {
            console.log("super app --> ", this.appService._appData.SUPER_APP);
            if (this.appService._appData.SUPER_APP != undefined) {
                let url;
                if (this.appService && this.appService.readCookie("is_kiosk")) {
                    url = window.location.origin + "/" + this.appService._appData.DEFAULT_APPLICATION + "/loginwithkiosk";
                } else if (this.appService && this.appService.readCookie("is_otpkiosk")) {
                     url = window.location.origin + "/" + this.appService._appData.DEFAULT_APPLICATION + "/loginwithotpkiosk";
                } else {
                    url = window.location.origin + "/" + this.appService._appData.DEFAULT_APPLICATION + "/login";
                }
                console.log("login url --> ", url);
                this.redirect(url, "_self").then(() => {
                    // window.location.reload();
                });
            } else {
                this.redirectToLogin()
            }
        });
    }

    redirect(url: string, target = '_blank'): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            try { resolve(!!window.open(url, target)); }
            catch (e) { reject(e); }
        });
    }

    redirectToLogin() {
        let redirectLink = "/login"
        if (this.appService && this.appService._iskiosk) {
            redirectLink = "/loginwithkiosk";
            if(this.appService.readCookie("is_otpkiosk")){
                redirectLink = "/loginwithotpkiosk"
            }
        }
        this.router.navigate([redirectLink]).then(() => {
            // this.appService._iskiosk = false;
            window.location.reload();
        });
    }

    getCachedData(key) {
        return this.cacheObj[key] != undefined && this.cacheObj[key] ? this.cacheObj[key] : false;
    }

    setCachedData(key, data) {
        this.cacheObj[key] = data;
    }

    public decryptText(key, encryptedCipherText) {
        if (key == '' || encryptedCipherText == '' || !encryptedCipherText || !key) {
            return encryptedCipherText;
        }
        try {
            var ivString = key.substring(0, 16);
            var parsedBase64Key = CryptoJS.enc.Utf8.parse(key);
            var decryptedData = CryptoJS.AES.decrypt(encryptedCipherText, parsedBase64Key, {
                iv: CryptoJS.enc.Utf8.parse(ivString),
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });
            return decryptedData.toString(CryptoJS.enc.Utf8);
        } catch (e) {
            console.debug("decryption error", encryptedCipherText);
            console.error(e);
            //this.logErrors("", 'front-end', "decryption error  encryptedCipherText-- " + encryptedCipherText + 'error from js is as --' + e);
            return encryptedCipherText;
        }

    }

    getUserInfoBasedOnKeys(key) {
        if (localStorage && localStorage.hasOwnProperty('currentUser')) {
            let data = JSON.parse(localStorage.getItem('currentUser'));
            switch (key) {
                case "user_id":
                    return data[key] ? data[key] : '';
                case "login_id":
                    return data[key] ? data[key] : '';
                case "user_type":
                    return data[key] ? data[key] : '';
                case "first_name":
                    return data[key] ? data[key] : '';
                default:
                    return ""
            }
        }
    }

    prePareFront_endErrorObj(errorType, stackTrace) {
        let error_logs = {
            application: this.getAppName(),
            current_url: window.location.href,
            type: errorType,
            category: errorType,
            user_id: this.getUserInfoBasedOnKeys("user_id"),
            full_strack_trace: stackTrace, //Error strack track which will logged in error handling service
            g_creation_datetime: Date.now(), //
            meta_data: "", //( it will be an open object , In case of fronted , current data in localhost and anything else we can log, in case of backend class name etc)
            account_id: this.getOrganizationKeys('account_id'),
            facility_id: this.getOrganizationKeys('org_id'), // (if present)
            account_name: this.getUserInfoBasedOnKeys("first_name"),
            user_name: this.getUserInfoBasedOnKeys("first_name"),
            facility_name: this.getOrganizationKeys('org_name'),
            resource_name: localStorage.CurrentResource ? localStorage.CurrentResource : '',
            resource_action: "MODIFY",
            resource_id: 'id',
            current_data: sessionStorage.currentData ? sessionStorage.currentData : '',
            is_front_end: true,
            currentTitle: this.setDefaultTitle(),
            current_role: localStorage.CURRENT_ROLE ? JSON.parse(localStorage.CURRENT_ROLE) : {}
        };
        return error_logs;
    }

    checkErrorBeforeSaving(stackTrace) {
        if (stackTrace && stackTrace.includes('NG0100')) {
            return false
        }
        return true
    }

    getOrganizationKeys(key) {
        let org = this.appService.getOrganization();
        if (org) {
            return org[key] ? org[key] : '';
        }
    }

    logErrors(error, errorType, stackTrace) {
        if (errorType == 'front-end') {
            if (this.checkErrorBeforeSaving(stackTrace)) {
                this.postErrorObjToDB(this.prePareFront_endErrorObj(errorType, stackTrace))
            }
        } else if (errorType == 'back-end') {
            this.postErrorObjToDB(this.prePareBack_endErrorObj(error, errorType, stackTrace))
        }
    }

    postErrorObjToDB(data) {
        this.action(data, "add", "account-management", 'audit_log', false).subscribe((res) => {
            if (res) {
                //TODO
            }
        }, (err) => {
        })
    }

    prePareBack_endErrorObj(error, errorType, stackTrace) {
        let error_logs = {
            application: this.getAppName(),
            current_url: window.location.href,
            category: errorType,
            user_id: this.getUserInfoBasedOnKeys("user_id"),
            g_creation_datetime: Date.now(), //
            meta_data: error.error, //( it will be an open object , In case of fronted , current data in localhost and anything else we can log, in case of backend class name etc)
            account_id: this.getOrganizationKeys('account_id'),
            facility_id: this.getOrganizationKeys('org_id'), // (if present)
            account_name: this.getUserInfoBasedOnKeys("first_name"),
            user_name: this.getUserInfoBasedOnKeys("first_name"),
            facility_name: this.getOrganizationKeys('org_name'),
            response_code: error.status, // back-end error code 
            response_data: error.message,
            resource_name: localStorage.CurrentResource ? localStorage.CurrentResource : '',
            error_name: error.statusText,
            resource_type: localStorage.CurrentResource ? localStorage.CurrentResource : '',
            response_message: error.statusText,
            error_url: error.url,
            current_data: sessionStorage.currentData ? sessionStorage.currentData : '',
            is_front_end: true,
            errorType: error.name,
            resource_action: "LIST"
        };
        return error_logs;
    }

    getDistaneAndTime$(points): Observable<any> {
        return Observable.create(observer => {
            var service = new google.maps.DistanceMatrixService();
            service.getDistanceMatrix({
                origins: points.origins,
                destinations: points.destinations,
                travelMode: google.maps.TravelMode.DRIVING,
                unitSystem: google.maps.UnitSystem.METRIC,
                avoidHighways: false,
                avoidTolls: false,
                transitOptions: {
                    departureTime: new Date(),
                }
            }, function (response, status) {
                if (status != google.maps.DistanceMatrixStatus.OK && response.rows[0].elements[0].status == "ZERO_RESULTS") {
                    observer.next({ error: "location is wrong" });
                } else {
                    observer.next(response.rows)
                }
            }, function (err) {
                observer.next({});
            });
        });
    }
    /************FOR DECRYPTION ****/
    /******* DASHBOARD CHANGE ****/

    changeDashboardUrl() {
        var routerConfig = this.router.config;
        if (routerConfig.length) {
            for (let i = 0; i < routerConfig.length; i++) {
                var singleRouter = routerConfig[i];
                if (singleRouter.path == this.appService._appData.DEFAULT_APPLICATION + '/dashboard') {
                    console.log("found dahsboard");
                    return;
                }

                if (singleRouter.children != undefined && singleRouter.children.length) {
                    for (let j = 0; j < singleRouter.children.length; j++) {
                        var singleRouterChildren = singleRouter.children[j];
                        if (singleRouterChildren.path == this.appService._appData.DEFAULT_APPLICATION + '/dashboard') {
                            delete singleRouterChildren.component;
                            delete singleRouterChildren.data;
                            singleRouterChildren.pathMatch = "full";
                            delete singleRouterChildren.canActivate;
                            if (this.appService._currentSessionData.dashboardUrlFound != undefined) {
                                singleRouterChildren.redirectTo = "/" + this.appService._currentSessionData.dashboardUrlFound;
                            } else {
                                singleRouterChildren.redirectTo = this.appService._appData.DEFAULT_APPLICATION + '/dash-board';
                                this.appService._currentSessionData.dashboardUrlFound = singleRouterChildren.redirectTo;
                            }
                            this.router.resetConfig(routerConfig);
                            return;
                        }
                    }
                }

            }
        }
    }
    getModalSize(size?: string) { // check modal size before open popup
        switch (size) {
            case 'sm': {
                return ModalSize.Sm
                break;
            }
            case 'md': {
                return ModalSize.Md
                break;
            }
            case 'lg': {
                return ModalSize.Lg
                break;
            }
            case 'xl': {
                return ModalSize.Xl
                break;
            }
            case 'xxl': {
                return ModalSize.XXl
                break;
            }
            default: {
                return ModalSize.Md
                break;
            }
        }
    }

    /******* DASHBOARD CHANGE ****/
    /******* GOOGLE MAPS KEY ****/
    getloadScript$(callback?: any) { //change key for subscribe value
        if (!this.scriptLoaded) {
            this.returnScriptKey$()
                .pipe(take(1))
                .subscribe((res) => {
                    let node = document.createElement('script');
                    node.src = "https://maps.googleapis.com/maps/api/js?key=" + res.resource[0]['value'] + "&libraries=" + this.getlibrary$()
                    node.type = 'text/javascript';
                    node.async = true;
                    node.charset = 'utf-8';
                    document.getElementsByTagName('head')[0].appendChild(node);
                    this.scriptLoaded = true;
                    if (callback) {
                        node.onload = () => callback();
                    }
                })
        }
        else {
            if (callback)
                callback()
        }
    }


    // async getCountry(lat: number, lon: number,account_id:any): Promise<{ name: string; code: string } | null> {
    //     try {
    //         const res = await firstValueFrom(this.returnScriptKeywithoutLogin$(account_id));
    //         if (!res.resource || res.resource.length === 0) {
    //             return null;
    //         }
    //         const apiKey = res.resource[0].value;
    //         const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lon}&key=${apiKey}`;

    //         const resp = await fetch(url);
    //         if (!resp.ok) throw new Error(`Failed to fetch geocode data`);
    //         const data = await resp.json();

    //         for (const result of data.results) {
    //             const country = result.address_components.find((c: any) =>
    //                 c.types.includes("country")
    //             );
    //             if (country) {
    //                 return {
    //                     name: country.long_name,
    //                     code: country.short_name,
    //                 };
    //             }
    //         }

    //         return null;
    //     } catch (err) {
    //         console.error(err);
    //         return null;
    //     }
    // }


    returnScriptKey$(): Observable<any> {
        // var args = "key:google_maps_key";
        return this.get("GET_CREDENTIALS_MAPS", "", "third_party_app_credentials", "system-management")
    }

    // returnScriptKeywithoutLogin$(account_id): Observable<any> {
    //     // var args = "key:google_maps_key,account_url:"+window.location.hostname;
    //     var args = "key:google_maps_key,account_url:" + account_id
    //     return this.get("GET_CREDENTIALS_LOGIN", args, "third_party_app_creds_login", "system-management")
    // }

    getlibrary$() {
        return "geometry,places";
    }
    openConfirmPopup(title, content, returnUrl?) {
        const dialogRef = this.modalService.confirm(title, content)
        dialogRef.subscribe(result => {
            if (result) {
                console.log("ok selected")
            }

        },
            () => {
                if (returnUrl)
                    this.router.navigate([returnUrl])
            });
    }
    validateParams(str) {
        if (str) {
            if (str.includes(',')) {
                var comma = str.split(',');
                for (let d of comma) {
                    if (d.includes(':')) {
                        var colon = d.split(':');
                        if (colon[1] == "" || colon[1] == undefined || colon[1] == null) {
                            return false;
                        }
                    }
                }
                return true;
            } else {
                if (str.includes(':')) {
                    if (str.split(':')[1] == null || str.split(':')[1] == '' || str.split(':')[1] == undefined) {
                        return false
                    } else {
                        return true
                    }
                }
            }
        } else {
            return true;
        }
    }

    getUrlParam(paramName) {
        if (this.route.snapshot != undefined && this.route.snapshot.queryParams != undefined && this.route.snapshot.queryParams['paramName'] != undefined) {
            return this.route.snapshot.queryParams[paramName];
        } else {
            const url = window.location.href;
            let paramValue;
            if (url.includes('?')) {
                const httpParams = new HttpParams({ fromString: url.split('?')[1] });
                paramValue = httpParams.get(paramName);
            }
            return paramValue;
        }
    }

    unsetComposite(data, key) {
        unset(data, key);
    }

    cleanObject(object) {
        var k: any;
        Object
            .entries(object)
            .forEach(([k, v]) => {
                if (v && typeof v === 'object') {
                    this.cleanObject(v);
                }
                if (v && typeof v === 'object' && !Object.keys(v).length || v === null || v === undefined || v == "") {
                    if (Array.isArray(object)) {
                        let j: any = k;
                        object.splice(j, 1);
                    } else {
                        delete object[k];
                    }
                }
            });
        return object;
    }

    setFavIcon() {
        var header = this.appService.getAppHeader();
        if (header && header.fav_icon != undefined) {
            document.getElementById('appFavicon').setAttribute('href', header.fav_icon);
        }
    }
    //this function returns array of objects which contains dynamiv values as per the data given
    createCumilativeObj(action_obj) {
        var cumulativeInfo = [];
        for (let singleItem of action_obj.items) {
            let cumulativeInfoObject = JSON.parse(JSON.stringify(action_obj.action.file_data.cumulativeInfo));
            if (cumulativeInfoObject.args != undefined) {
                cumulativeInfoObject.args = this.buildDyanamicStr(cumulativeInfoObject.args, { data: singleItem });
            }

            if (cumulativeInfoObject.reportTemplateId != undefined) {
                let item = singleItem;
                let dynamicTemplateId = eval(cumulativeInfoObject.reportTemplateId);
                cumulativeInfoObject.reportTemplateId = dynamicTemplateId;
            }

            if (cumulativeInfoObject.filter != undefined) {
                cumulativeInfoObject.filter = this.buildDyanamicStr(cumulativeInfoObject.filter, { data: singleItem });
            }
            if (cumulativeInfoObject.data != undefined) {
                cumulativeInfoObject.data = this.buildDyanamicStr(cumulativeInfoObject.data, { data: singleItem });
            }
            cumulativeInfo.push(cumulativeInfoObject);
        }
        return cumulativeInfo;
    }
    //this function will take obj which will contain resource application etc to redirect to that
    redirectToOtherPage(obj, data, gridData?, dhsData?) {
        //checking existence of application in obj
        let application = obj.application != undefined && obj.application ? obj.application : this.getAppName();
        //checking existence of resource  in obj
        let resource = obj.resource != undefined && obj.resource ? obj.resource : this._resourceName;
        let custom_params
        if (obj.current_row_queryParams != undefined) {
            custom_params = obj.current_row_queryParams != undefined && obj.current_row_queryParams ? JSON.parse(this.buildDyanamicStr(JSON.stringify(obj.current_row_queryParams), { data: data.data })) : {};
        } else {
            custom_params = obj.queryParams != undefined && obj.queryParams ? JSON.parse(this.buildDyanamicStr(JSON.stringify(obj.queryParams), { data: data })) : {};
        }
        let query_params = obj.query_params != undefined && obj.query_params ? this.buildDyanamicStr(obj.query_params, { data: data }) : {};
        if (obj.query_params != undefined)
            query_params = { "query_params": query_params }
        let queryParams = { "returnUrl": obj.returnUrl != undefined && obj.returnUrl ? obj.returnUrl : this.router.url }
        let finalParam = {};
        // if needed to set gridData (datasource) in route
        if (obj.saveGridData != undefined && obj.saveGridData && gridData != undefined && gridData && dhsData) {
            queryParams['saveGridData'] = obj.saveGridData;
            queryParams = { ...queryParams, ...gridData };
            sessionStorage.setItem('data_grid_ids', JSON.stringify(dhsData));
        }
        if (obj.query_params != undefined)
            finalParam = { ...custom_params, ...queryParams, ...query_params };
        else
            finalParam = { ...custom_params, ...queryParams };
        // router.navigate only accepts string queryParam values; object values (eg. banner) must be
        // stringified here so components can JSON.parse(route.snapshot.queryParams.banner) as usual
        Object.keys(finalParam).forEach(paramKey => {
            if (finalParam[paramKey] != null && typeof finalParam[paramKey] === 'object') {
                finalParam[paramKey] = JSON.stringify(finalParam[paramKey]);
            }
        });
        var route
        if (obj.redirectLink == undefined) {
            route = `${application}${obj.key != undefined && obj.key ? `/${data[obj.key]}` : ''}/${resource}${obj.path != undefined && obj.path ? `/${obj.path}` : ''}`;
        } else if (obj.redirectLink != undefined && obj.redirectLink.includes("!!!")) {
            route = this.buildDyanamicStr(obj.redirectLink, { data: data })
        } else {
            route = `${obj.redirectLink}`;
        }
        this.router.navigate([route], { queryParams: finalParam });
    }

    setTeleService(obj) {
        this.appService._currentData.teleService = obj;
    }

    getTeleService() {
        return this.appService._currentData.teleService;
    }

    getPatientUHID(): Observable<any> {
        return this.getData({ args: "id:" + this.authenticationService.getCurrentUser().user_id }, "", "patient", "patient-registration", "GET_BY_ID")
    }


    getFaclityObj(facility_id) {
        if (this.appService.isFacilityAware())
            return (this.appService._currentSessionData.facilityList[facility_id] != undefined) ? this.appService._currentSessionData.facilityList[facility_id] : false;
        else
            return { name: this.appService.getOrganization().org_name, primary_address: this.getfacilityAddress() }
    }

    getfacilityAddress() {
        let address = this.appService.getCurrentAddress()
        let street1 = this.decryptText(this.authenticationService.getEnryptionKey(), this.appService.getCurrentAddress().street1)
        let street2 = this.decryptText(this.authenticationService.getEnryptionKey(), this.appService.getCurrentAddress().street2)
        address['street1'] = street1; address['street2'] = street2
        return address
    }

    getStorageFacility(callback) {
        this.storageService.getSessionStorageDataSimple(this.appService.getAppData().ORG_KEY, facility_id => {
            if (!facility_id) {
                callback(false);
            } else {
                try {
                    var facilityObj = this.getFaclityObj(facility_id);
                    if (facilityObj) {
                        facilityObj["facility_id"] = facility_id;
                        callback(facilityObj);
                    } else {
                        callback(false);
                    }
                } catch (e) {
                    callback(false);
                }
            }
        });
    }
    printMobile(url, callback?) {
        if (this.utilService.isiOS()) {
            let a: any = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = url;
            a.target = "_blank";
            a.download = "Print";
            a.click();
            document.body.removeChild(a);
            if (callback)
                callback(true)
        } else {
            var w = window.open(url, '_blank');
            if (callback)
                callback(true)
        }
    }

    printTemplateSetting(templateId: string): Observable<any> {
        if (Array.isArray(this.appService?.printTemplateSettings) && this.appService.printTemplateSettings.length > 0) {
            const cached_response = this.appService.printTemplateSettings.find(
                obj => obj?.print_template_id === templateId
            );
            if (cached_response && Object.keys(cached_response).length > 0) {
                return of(cached_response);
            }
        }

        let gridData = {
            projectionKeys: ["isUserPrint", "print_template_id", "id", "account_name", "facility_name", "print_without_h_f", "no_of_print_copy", "override_print_copies", "page_layout"],
            query_id: "GET_PRINT_TEMPLATE_SETTINGS_DETAILS",
            args: templateId ? "print_template_id:" + templateId : ""
        };
        return this.getData(gridData, "", "print_template_settings", "printengine", gridData.query_id).pipe(
            map((result: any) => {
                if (result.errCode === 0 && result.resource?.length > 0) {
                    const fetched = result.resource[0];
                    if (fetched?.print_template_id != null) {
                        this.appService.printTemplateSettings.push(fetched);
                    }
                    return fetched;
                }
                return {};
            })
        );
    }

    setContextForPatient(context: boolean) {
        this.patientChanged = context;
    }

    getContextForPatient() {
        return this.patientChanged;
    }

    generateIDfromText(text) {
        return text.replace(/\W/g, '_');
    }
    generateID(length: number) {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
        var charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    generateDeviceID() {
        const KX_SERVER = `${window.location.protocol}//karexpert.kxtec.in:8443`;

        if (this.appService.readCookie('device_id')) {
            setTimeout(() => this._checkKxServerUpdate(KX_SERVER), 20000);
            return;
        }

        const ctrl = new AbortController();
        const timer = setTimeout(() => ctrl.abort(), 2000);

        fetch(`${KX_SERVER}/audit`, { signal: ctrl.signal })
            .then(r => { clearTimeout(timer); if (!r.ok) throw new Error(); return r.json(); })
            .then(data => {
                const machineId = data?.server_machine_id;
                if (machineId) {
                    this.appService.writeCookie('device_id', machineId, 365);
                }
                setTimeout(() => this._checkKxServerUpdate(KX_SERVER), 20000);
            })
            .catch(() => {
                clearTimeout(timer);
                const newId = this.generateID(9) + '__' + new Date().getTime();
                this.appService.writeCookie('device_id', newId, 365);
            });
    }

    private _checkKxServerUpdate(baseUrl: string) {
        fetch(`${baseUrl}/update/check`)
            .then(r => r.ok ? r.json() : null)
            .then(info => {
                if (!info?.update_available) return;
                if (this.appService.readCookie('kx_update_skip') === info.latest_version) return;
                const ok = window.confirm(
                    `KX Server update available!\n\nCurrent: v${info.current_version}  →  Latest: v${info.latest_version}\n\nApply update now? The server will restart briefly.`
                );
                if (!ok) {
                    const now = new Date();
                    const midnight = new Date(now);
                    midnight.setHours(24, 0, 0, 0);
                    const daysLeft = (midnight.getTime() - now.getTime()) / 86400000;
                    this.appService.writeCookie('kx_update_skip', info.latest_version, daysLeft);
                    return;
                }
                fetch(`${baseUrl}/update/apply`, { method: 'POST' }).catch(() => { });
            })
            .catch(() => { });
    }

    checkForSpecialChar(string) {
        var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,./~`-=";
        for (let i = 0; i < specialChars.length; i++) {
            if (string.indexOf(specialChars[i]) > -1) {
                return true
            }
        }
        return false;
    }

    reloadCurrentUrl() {
        this.loaderService.showSpinner()
        const prev = this.router.routeReuseStrategy.shouldReuseRoute;
        const prevOSN = this.router.onSameUrlNavigation;
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigateByUrl(this.router.url);
        setTimeout(() => {
            this.router.routeReuseStrategy.shouldReuseRoute = prev;
            this.router.onSameUrlNavigation = prevOSN;
        }, 0);
        this.loaderService.hideSpinner()
    }

    checkForSpecialAllowedChar(string, pattern) {
        var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,./~`-=";
        for (let i = 0; i < specialChars.length; i++) {
            if (string.indexOf(specialChars[i]) > -1 && pattern.indexOf(specialChars[i]) == -1) {
                return true
            }
        }
        return false;
    }

    convertToPlain(html) {
        // Create a new div element
        var tempDivElement = document.createElement("div");
        // Set the HTML content with the given value
        tempDivElement.innerHTML = html;
        // Retrieve the text property of the element 
        return tempDivElement.textContent || tempDivElement.innerText || "";
    }

    encodeURIPrintGridData(gridData): any { // encode grid data in print for translation.
        if (gridData && gridData.printInfo) {
            if (gridData.printInfo.gridHeading) {
                gridData.printInfo.gridHeading = encodeURIComponent(gridData.printInfo.gridHeading);
            }
            if (gridData.printInfo.filterPrintInfo) {
                var filterinfo = gridData.printInfo.filterPrintInfo;
                this.modifyKeys(filterinfo);
                gridData.printInfo.filterPrintInfo = filterinfo;
            }
            if (gridData.printInfo.bannerInfo) {
                gridData.printInfo.bannerInfo.forEach(element => {
                    element.heading = encodeURIComponent(element.heading);
                });
            }
            if (gridData.printInfo.gridInfo) {
                gridData.printInfo.gridInfo.forEach(element => {
                    if (element.heading.includes('<'))
                        element.heading = this.convertToPlain(element.heading);
                    element.heading = encodeURIComponent(element.heading);
                });
            }
        }
        return gridData;
    }

    checkKioskApp() {
        return this.router.url.includes("loginwithkiosk") || this.router.url.includes("loginwithotpkiosk") ? true : false;
    }

    modifyKeys(obj) {
        Object.keys(obj).forEach(key => {
            var get_key = key;
            var encoded_key = encodeURIComponent(`${key}`);
            obj[encoded_key] = obj[key];
            if (get_key != encoded_key)
                delete obj[key];
            if (typeof obj[encoded_key] === "object") {
                this.modifyKeys(obj[encoded_key]);
            }
        });
    }

    async searchAndFilterMenu(searchVal?: string, layout?: any): Promise<any> {
        if (!searchVal) return layout;

        const current_data: any = {};

        // Step 1: Filter based on permission & visibility
        Object.keys(layout).forEach(key => {
            const { data } = layout[key];
            if (!data) return;

            if (data.hasOwnProperty('visible') && data.visible === false) {
                return; // skip invisible
            }

            if (data.permission_required) {
                if (this.rolePermissionService.checkAccessPermission(data.action_name, data.resource)) {
                    current_data[key] = layout[key];
                }
            } else {
                current_data[key] = layout[key];
            }
        });

        // Step 2: Prepare translation promises
        const promiseCalls: Promise<any>[] = [];
        Object.keys(current_data).forEach(key => {
            const layoutItem = current_data[key];
            if (!layoutItem?.data || !layoutItem?.resource_def) return;

            // Main menu translation
            if (layoutItem.data.layoutName) {
                promiseCalls.push(
                    this.asyncLanguageProcess(layoutItem.data.layoutName)
                        .then(res => ({ type: "main", key, res }))
                );
            }

            // Nested layouts translation
            layoutItem.resource_def.layout?.forEach((item: any, idx: number) => {
                if (item?.layoutName) {
                    promiseCalls.push(
                        this.asyncLanguageProcess(item.layoutName)
                            .then(res => ({ type: "nested", key, idx, res }))
                    );
                }
            });
        });

        const results = await Promise.all(promiseCalls);

        // Step 3: Convert results into lookup maps for efficiency
        const mainMap = new Map<string, string>();
        const nestedMap: Record<string, string> = {};

        results.forEach(r => {
            if (r.type === "main") {
                mainMap.set(r.key, r.res);
            } else if (r.type === "nested") {
                nestedMap[`${r.key}_${r.idx}`] = r.res;
            }
        });

        // Step 4: Filter by search value
        const value: any = {};
        Object.keys(current_data).forEach(key => {
            const layoutItem = current_data[key];
            if (!layoutItem?.data || !layoutItem?.resource_def) return;

            const translatedMain = mainMap.get(key) || layoutItem.data.layoutName;

            // Check main menu match
            const mainMenuFound = translatedMain?.toLowerCase().includes(searchVal);

            // Check nested menu matches
            // const childMenuFound = layoutItem.resource_def.layout?.filter((item: any, idx: number) => {
            //     //const translatedChild = nestedMap[`${key}_${idx}`];
            //     //const idMatch = typeof item.id === "string" && item.id.toLowerCase().includes(searchVal);
            //     //const actionMatch = typeof item.action_name === "string" && item.action_name.toLowerCase().includes(searchVal);

            //     return (
            //         translatedChild?.toLowerCase().includes(searchVal) 
            //         //||
            //         //idMatch 
            //         //||
            //         //actionMatch
            //     );
            // });

            if (mainMenuFound /*|| (childMenuFound && childMenuFound.length > 0)*/) {
                value[key] = {
                    ...layoutItem,
                    data: {
                        ...layoutItem.data,
                        translatedName: translatedMain
                    },
                    resource_def: {
                        ...layoutItem.resource_def,
                        layout: mainMenuFound ? layoutItem.resource_def.layout : ""//childMenuFound
                    }
                };
            }
        });
        return value;
    }
    getWithCache(key: string, apiCallFn: () => Observable<any>) {
        const cachedData = this.getCachedData(key);
        //Return cache if available
        if (cachedData) {
            return of({
                fromCache: true,
                data: cachedData
            });
        }
        //Prevent duplicate API calls
        if (this.ongoingRequests.has(key)) {
            return this.ongoingRequests.get(key);
        }
        const request$ = apiCallFn().pipe(
            tap((res) => {
                if (res?.resource?.length) {
                    this.setCachedData(key, res.resource);
                }
            }),
            map((res) => ({
                fromCache: false,
                data: res?.resource || []
            })),
            finalize(() => this.ongoingRequests.delete(key)),
            shareReplay(1)
        );
        this.ongoingRequests.set(key, request$);
        return request$;
    }


    async fetchFilesAsBlobUrls(ids: string[], documentType: string): Promise<{ url: string; type: string; name: string }[]> {
        const mimeToCategory = (mime: string): string => {
            if (!mime) return 'document';
            if (mime.startsWith('image/')) return 'image';
            if (mime.startsWith('audio/')) return 'audio';
            if (mime.startsWith('video/')) return 'video';
            if (mime === 'application/pdf') return 'pdf';
            return 'document';
        };
        const nameFromHeaders = (headers: any, fallback: string): string => {
            const disposition: string = headers.get('content-disposition') || '';
            const match = disposition.match(/filename\*?=(?:UTF-8'')?["']?([^"';\n]+)["']?/i);
            return match ? decodeURIComponent(match[1].trim()) : fallback;
        };
        return Promise.all(ids.map(async id => {
            const url = this.getApiEndpoint('dms') + documentType + '/image-response-entity?args=id:' + id + '&application=dms';
            try {
                const response: any = await firstValueFrom(this.getFileByUrlWithHeader(url, false));
                return {
                    url: URL.createObjectURL(response.body),
                    type: mimeToCategory(response.headers.get('content-type')),
                    name: nameFromHeaders(response.headers, String(id))
                };
            } catch {
                return { url: null, type: null, name: String(id) };
            }
        }));
    }
}

//for encodine issue of texteditor (special symbols)
export class HttpFormEncodingCodec implements HttpParameterCodec {
    encodeKey(k: string): string { return encodeURIComponent(k).replace(/%20/g, '+'); }

    encodeValue(v: string): string { return encodeURIComponent(v).replace(/%20/g, '+'); }

    decodeKey(k: string): string { return decodeURIComponent(k.replace(/\+/g, ' ')); }

    decodeValue(v: string) { return decodeURIComponent(v.replace(/\+/g, ' ')); }
}

export const DEFAULT_TIMEOUT = new InjectionToken<number>('defaultTimeout');

@Injectable()
export class TimeoutInterceptor implements HttpInterceptor {
    constructor(@Inject(DEFAULT_TIMEOUT) protected defaultTimeout: number) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const timeoutValue = req.headers.get('timeout') || this.defaultTimeout;
        const timeoutValueNumeric = Number(timeoutValue);

        return next.handle(req).pipe(timeout(timeoutValueNumeric));
    }
}
